import type { CSSProperties } from "react";

// Exact immutable icon registry extracted from the shipped Mac renderer.
// @evidence src/app/dist/renderer/assets/index-UbX-y3il.js#sha256=ef4e9831b65d39633f09c9ad0c083b98b7ebf52e3bb558182aee5bde31f876fa#byteOffset=123956 (q5t outline map)
// @evidence src/app/dist/renderer/assets/index-UbX-y3il.js#sha256=ef4e9831b65d39633f09c9ad0c083b98b7ebf52e3bb558182aee5bde31f876fa#byteOffset=138317 (j5t filled map)
// @evidence recovered/frontend/app/assets/index-UbX-y3il.js#sha256=80464803b50f478598080bdc1b91da3996c6b74168e2351ea26f620f2ec62ba5#source-equivalent q5t/j5t maps
// The font is already recovered at frontend/src/recovered/features/computer/shell/cursor-icons-16-f_W_ogc-.woff2.
// @evidence frontend/manifests/computer-shell-evidence.json#assets.cursor-icons-16-f_W_ogc-.woff2

export const SAND_ICON_OUTLINE_CODE_POINTS = {
  "account": 0xeb99,
  "add": 0xea60,
  "agent": 0xf413,
  "agent-circle": 0xf430,
  "agent-square": 0xf431,
  "agents": 0xf432,
  "agents-swarm": 0xf412,
  "alarm-clock": 0xf58b,
  "alert": 0xea6c,
  "archive": 0xea98,
  "army-base": 0xf433,
  "arrow-block-down": 0xf2c3,
  "arrow-block-left": 0xf2c4,
  "arrow-block-line-down": 0xf56e,
  "arrow-block-line-left": 0xf570,
  "arrow-block-line-right": 0xf572,
  "arrow-block-line-up": 0xf574,
  "arrow-block-right": 0xf2c5,
  "arrow-block-up": 0xf2c6,
  "arrow-bracket-from-down": 0xf34e,
  "arrow-bracket-from-left": 0xf34f,
  "arrow-bracket-from-right": 0xf359,
  "arrow-bracket-from-up": 0xec28,
  "arrow-bracket-from-up-dashed": 0xec27,
  "arrow-bracket-to-down": 0xec26,
  "arrow-bracket-to-left": 0xf358,
  "arrow-bracket-to-right": 0xf357,
  "arrow-bracket-to-up": 0xf356,
  "arrow-ccw": 0xead2,
  "arrow-circle-down": 0xebfc,
  "arrow-circle-left": 0xebfd,
  "arrow-circle-right": 0xebfe,
  "arrow-circle-up": 0xebff,
  "arrow-cw": 0xeb37,
  "arrow-down": 0xea9a,
  "arrow-left": 0xea9b,
  "arrow-left-down": 0xf2c7,
  "arrow-left-up": 0xf2c8,
  "arrow-right": 0xea9c,
  "arrow-right-down": 0xf2c9,
  "arrow-right-up": 0xedc1,
  "arrow-square-down": 0xf2f3,
  "arrow-square-from-down": 0xf355,
  "arrow-square-from-left": 0xf354,
  "arrow-square-from-right": 0xea6e,
  "arrow-square-from-up": 0xebac,
  "arrow-square-left": 0xf2f5,
  "arrow-square-left-down": 0xf2fc,
  "arrow-square-left-top": 0xf2fb,
  "arrow-square-left-up": 0xf2fb,
  "arrow-square-right": 0xf2f4,
  "arrow-square-right-down": 0xf2fa,
  "arrow-square-right-top": 0xedc2,
  "arrow-square-right-up": 0xedc2,
  "arrow-square-to-down": 0xedae,
  "arrow-square-to-left": 0xf353,
  "arrow-square-to-right": 0xea6f,
  "arrow-square-to-up": 0xf352,
  "arrow-square-up": 0xf2f6,
  "arrow-swap": 0xebcb,
  "arrow-u-up-left": 0xed84,
  "arrow-u-up-right": 0xf31e,
  "arrow-up": 0xeaa1,
  "arrows-both-horizontal": 0xea99,
  "arrows-both-vertical": 0xf2ca,
  "arrows-ccw": 0xf30f,
  "arrows-ccw-angular": 0xf2cc,
  "arrows-contract": 0xf310,
  "arrows-contract-simple": 0xf2cd,
  "arrows-cw": 0xea77,
  "arrows-down-up": 0xf2ce,
  "arrows-expand": 0xf311,
  "arrows-expand-simple": 0xf2cf,
  "arrows-left-right": 0xebcb,
  "arrows-out-cardinal": 0xeb22,
  "asterisk": 0xedbf,
  "at": 0xec55,
  "atom": 0xf434,
  "bandaid": 0xf435,
  "banknote": 0xf500,
  "banknotes-stack": 0xf436,
  "barbell": 0xf437,
  "basketball": 0xf438,
  "beach-umbrella": 0xf439,
  "beaker": 0xea79,
  "beaker-stop": 0xebe1,
  "beehouse": 0xf43a,
  "bell": 0xeaa2,
  "bell-dot": 0xeb9a,
  "bell-slash": 0xec08,
  "binary": 0xeae8,
  "binoculars": 0xeb68,
  "bluetooth": 0xf43b,
  "board-kanban": 0xeb30,
  "book": 0xf414,
  "book-open": 0xeaa4,
  "bookmark": 0xeaa5,
  "books": 0xeb9c,
  "bowtie": 0xf4f2,
  "bracket": 0xeb0f,
  "bracket-dot": 0xebe5,
  "bracket-error": 0xebe6,
  "brackets-curly": 0xeb0f,
  "brackets-curly-dot": 0xebe5,
  "brackets-curly-x": 0xebe6,
  "brackets-square": 0xea8a,
  "brain": 0xed87,
  "brain-hourglass": 0xf43c,
  "brain-simple": 0xf43d,
  "brain-simplest": 0xf43e,
  "brain-slash": 0xf43f,
  "briefcase": 0xeaac,
  "browser": 0xeaae,
  "browsers": 0xeb23,
  "brush": 0xedb3,
  "bug": 0xeaaf,
  "bugbot": 0xec59,
  "building": 0xf440,
  "buildings": 0xf441,
  "bullseye": 0xebf8,
  "calculator": 0xf442,
  "calendar": 0xeab0,
  "calendar-hourglass": 0xf415,
  "camera": 0xeada,
  "car": 0xf443,
  "cardholder": 0xf444,
  "castle": 0xf445,
  "cd": 0xf446,
  "chart-bars": 0xeb03,
  "chart-line": 0xebe2,
  "chart-pie": 0xebe4,
  "chart-pyramid": 0xf419,
  "chart-scatter": 0xebe3,
  "chat-bubble": 0xed95,
  "chat-bubble-chevrons-left-right": 0xec37,
  "chat-bubble-ellipsis": 0xf34c,
  "chat-bubble-exclamation": 0xeb42,
  "chat-bubble-pencil": 0xedc3,
  "chat-bubble-question": 0xf23c,
  "chat-bubbles": 0xf350,
  "chat-bubbles-grid": 0xf424,
  "chatBubble": 0xed95,
  "chatBubble-ellipsis": 0xf34c,
  "chatBubble-exclamation": 0xeb42,
  "chatBubble-question": 0xf23c,
  "chatBubbles": 0xf350,
  "check": 0xeab2,
  "check-circle": 0xedba,
  "check-square": 0xf2d2,
  "checks": 0xebb1,
  "chef-hat": 0xf447,
  "chess-king": 0xf448,
  "chess-tower": 0xf449,
  "chevron-circle-down": 0xf576,
  "chevron-circle-left": 0xf578,
  "chevron-circle-right": 0xf57a,
  "chevron-circle-up": 0xf57c,
  "chevron-down": 0xeab4,
  "chevron-down-small": 0xf2d3,
  "chevron-left": 0xeab5,
  "chevron-left-small": 0xf2d4,
  "chevron-right": 0xeab6,
  "chevron-right-small": 0xf2d5,
  "chevron-up": 0xeab7,
  "chevron-up-small": 0xf2d6,
  "chevrons-down": 0xeaf3,
  "chevrons-down-up": 0xeaf5,
  "chevrons-left": 0xedd4,
  "chevrons-left-right": 0xf2d7,
  "chevrons-right": 0xf31d,
  "chevrons-right-dotted-left": 0xedc6,
  "chevrons-up": 0xeaf4,
  "chevrons-up-down": 0xedcb,
  "chip": 0xec19,
  "chip-simple": 0xf41a,
  "circle": 0xebb5,
  "circle-circle": 0xeba7,
  "circle-dashed": 0xedbb,
  "circles": 0xea97,
  "circles-check": 0xec2e,
  "clipboard": 0xedc9,
  "clock": 0xedc0,
  "clone": 0xebcc,
  "close": 0xed82,
  "cloud": 0xebaa,
  "cloud-arrow-down": 0xeac2,
  "cloud-arrow-up": 0xeac3,
  "cloud-download": 0xeac2,
  "cloud-upload": 0xeac3,
  "code": 0xf44a,
  "code-brackets": 0xea8a,
  "code-simple": 0xf44b,
  "cog": 0xeaf8,
  "collection": 0xf31f,
  "collection-plus": 0xf32b,
  "color-mode": 0xeac6,
  "command": 0xf2d8,
  "comment": 0xea6b,
  "comment-dashed": 0xec0e,
  "comment-discussion": 0xf350,
  "comment-dot": 0xec0a,
  "comments": 0xeac7,
  "compass": 0xebd5,
  "compass-check": 0xebd7,
  "compass-dot": 0xebd6,
  "conversation": 0xf350,
  "cookie": 0xf44c,
  "copilot": 0xec10,
  "copy": 0xebcc,
  "corners-in": 0xeb4d,
  "corners-out": 0xeb4c,
  "corners-out-check": 0xf2da,
  "corners-out-sparkle": 0xf44d,
  "cost-high": 0xf41b,
  "cost-low": 0xf41c,
  "cost-medium": 0xf41d,
  "credit-card": 0xeac9,
  "cross-medical": 0xf44e,
  "crosshair": 0xf44f,
  "crown": 0xf53e,
  "crystal-ball": 0xf450,
  "cube": 0xedcc,
  "cube-coordinates": 0xf451,
  "cube-nodes": 0xedc8,
  "cube-transparent": 0xf2db,
  "currency-btc": 0xf452,
  "currency-dollar": 0xf453,
  "currency-eth": 0xf454,
  "cursor-logo": 0xedd9,
  "cursor-text": 0xf304,
  "cutlery": 0xf455,
  "cylinder": 0xf456,
  "dashboard": 0xf457,
  "database": 0xeace,
  "database-network": 0xf458,
  "debug-pause": 0xf35c,
  "debug-restart": 0xead2,
  "debug-start": 0xf35a,
  "debug-stop": 0xeba5,
  "deckchair-umbrella": 0xf459,
  "desktop-download": 0xeac2,
  "device-camera": 0xeada,
  "device-camera-video": 0xead9,
  "device-desktop": 0xea7a,
  "device-mobile": 0xeadb,
  "diagram": 0xf41e,
  "diff": 0xeae1,
  "diff-added": 0xeadc,
  "diff-ignored": 0xeadd,
  "diff-modified": 0xeade,
  "diff-multiple": 0xec23,
  "diff-removed": 0xeadf,
  "diff-renamed": 0xeae0,
  "diff-single": 0xec22,
  "diff-single-arrow-right-up": 0xec0b,
  "diff-single-dot": 0xec0c,
  "discard": 0xed82,
  "display": 0xea7a,
  "display-check": 0xeb79,
  "display-circle": 0xeb7a,
  "display-connect": 0xeba9,
  "display-play": 0xeb7b,
  "display-waves": 0xf586,
  "displays": 0xf587,
  "dots-3-horizontal": 0xea7c,
  "dots-3-vertical": 0xeb10,
  "drop": 0xf4f4,
  "easel": 0xf45a,
  "edit": 0xea73,
  "elephant": 0xf4d5,
  "ellipsis": 0xea7c,
  "envelope": 0xeb1c,
  "envelope-open": 0xeb1b,
  "eraser": 0xeda0,
  "error": 0xea87,
  "exclamation-circle": 0xedbc,
  "exclamation-triangle": 0xea6c,
  "execution-parallel": 0xf410,
  "execution-sequential": 0xf411,
  "extensions": 0xeae6,
  "eye": 0xea70,
  "eye-closed": 0xf338,
  "eye-slash": 0xeae7,
  "fast-backward": 0xf416,
  "fast-forward": 0xf417,
  "feedback": 0xf34c,
  "file": 0xea7b,
  "file-add": 0xed8d,
  "file-arrow-right-up": 0xeaee,
  "file-binary": 0xea7b,
  "file-chevrons-left-right": 0xeae9,
  "file-code": 0xea7b,
  "file-directory": 0xea83,
  "file-directory-create": 0xea80,
  "file-image": 0xeaea,
  "file-list": 0xec53,
  "file-lock": 0xeafa,
  "file-media": 0xeaea,
  "file-pdf": 0xeaeb,
  "file-plus": 0xed8d,
  "file-text": 0xf45b,
  "file-type-adobe-illustrator": 0xf4ec,
  "file-type-adobe-photoshop": 0xf4ea,
  "file-type-babel": 0xf53a,
  "file-type-bazel": 0xf521,
  "file-type-bevy": 0xf526,
  "file-type-bicep": 0xf4fc,
  "file-type-biomejs": 0xf592,
  "file-type-bower": 0xf566,
  "file-type-bun": 0xf594,
  "file-type-c-plus-plus": 0xf4bf,
  "file-type-c-sharp": 0xf4c0,
  "file-type-clojure": 0xf4d3,
  "file-type-crystal": 0xf4d7,
  "file-type-cuda": 0xf540,
  "file-type-dart": 0xf596,
  "file-type-docker": 0xf490,
  "file-type-ejs": 0xf54c,
  "file-type-elixir": 0xf4ee,
  "file-type-eslint": 0xf534,
  "file-type-f-sharp": 0xf4d9,
  "file-type-firebase": 0xf4fa,
  "file-type-geckodriver": 0xf515,
  "file-type-git-meta": 0xf491,
  "file-type-go": 0xf492,
  "file-type-godot": 0xf51d,
  "file-type-grails": 0xf501,
  "file-type-graphql": 0xf493,
  "file-type-groovy": 0xf536,
  "file-type-grunt": 0xf568,
  "file-type-gulp": 0xf546,
  "file-type-haml": 0xf55e,
  "file-type-handlebars": 0xf553,
  "file-type-haskell": 0xf4e8,
  "file-type-ionic": 0xf494,
  "file-type-java": 0xf495,
  "file-type-javascript": 0xf496,
  "file-type-julia": 0xf497,
  "file-type-jupyter": 0xf511,
  "file-type-karma": 0xf498,
  "file-type-kotlin": 0xf499,
  "file-type-latex": 0xf509,
  "file-type-liquid": 0xf53c,
  "file-type-maven": 0xf550,
  "file-type-mustache": 0xf50b,
  "file-type-npm": 0xf517,
  "file-type-nunjucks": 0xf532,
  "file-type-ocaml": 0xf56a,
  "file-type-odata": 0xf505,
  "file-type-pdf": 0xf523,
  "file-type-perl": 0xf56c,
  "file-type-platformio": 0xf52a,
  "file-type-powershell": 0xf4f0,
  "file-type-prettier": 0xf598,
  "file-type-prisma": 0xf52e,
  "file-type-prolog": 0xf544,
  "file-type-puppet": 0xf4e6,
  "file-type-python": 0xf49a,
  "file-type-reason": 0xf548,
  "file-type-rescript": 0xf52c,
  "file-type-rollup": 0xf49b,
  "file-type-rust": 0xf49c,
  "file-type-sass": 0xf4fe,
  "file-type-sbt": 0xf54a,
  "file-type-scala": 0xf4c8,
  "file-type-slim": 0xf54e,
  "file-type-stylus": 0xf528,
  "file-type-sublime": 0xf507,
  "file-type-svelte": 0xf49d,
  "file-type-swift": 0xf49e,
  "file-type-terraform": 0xf49f,
  "file-type-typescript": 0xf4a0,
  "file-type-vala": 0xf51b,
  "file-type-vite": 0xf4a1,
  "file-type-vsc": 0xf519,
  "file-type-vue": 0xf4a2,
  "file-type-web-assembly": 0xf4ca,
  "file-type-webpack": 0xf4a3,
  "file-type-windows": 0xf4a4,
  "file-type-yarn": 0xf51f,
  "file-type-zig": 0xf538,
  "file-zip": 0xea7b,
  "files": 0xeaf0,
  "film-reel": 0xf45c,
  "film-strip": 0xf45d,
  "filter": 0xeaf1,
  "flag": 0xec3f,
  "flag-hill": 0xeb20,
  "flame": 0xeaf2,
  "flask": 0xea79,
  "flask-slash-circle": 0xebe1,
  "floppy-disc": 0xeb4b,
  "focus-window": 0xede6,
  "fold-dashed": 0xede9,
  "folder": 0xea83,
  "folder-active": 0xeaf6,
  "folder-arrow-right-up": 0xeaed,
  "folder-check": 0xeaf6,
  "folder-dashed": 0xf58d,
  "folder-library": 0xebdf,
  "folder-open": 0xeaf7,
  "folder-opened": 0xea83,
  "folder-plus": 0xea80,
  "folders": 0xeaec,
  "fork": 0xf41f,
  "funnel": 0xeaf1,
  "funnel-simple": 0xeb83,
  "game-controller": 0xf45e,
  "game-controller-retro": 0xf45f,
  "gauge": 0xeacd,
  "gear": 0xeaf8,
  "gem": 0xeb48,
  "gift": 0xeaf9,
  "git-branch": 0xedb4,
  "git-commit": 0xeafc,
  "git-commit-horizontal": 0xf303,
  "git-compare": 0xeafd,
  "git-fetch": 0xec1d,
  "git-fork": 0xea63,
  "git-merge": 0xeafe,
  "git-pull": 0xeb40,
  "git-pull-request": 0xea64,
  "git-pull-request-closed": 0xebda,
  "git-pull-request-create": 0xebbc,
  "git-pull-request-done": 0xec46,
  "git-pull-request-draft": 0xebdb,
  "git-push": 0xeb41,
  "github": 0xea84,
  "github-actions": 0xeaff,
  "globe": 0xeb01,
  "graduation-cap": 0xeb21,
  "graph": 0xeb03,
  "graph-line": 0xebe2,
  "graph-scatter": 0xebe3,
  "grid": 0xf460,
  "grid-plus": 0xf461,
  "grid-sparkle": 0xf462,
  "gripper": 0xeb04,
  "hamburger": 0xf463,
  "hammer": 0xedab,
  "hash": 0xf4a5,
  "hat": 0xf464,
  "headphones": 0xf465,
  "headset": 0xf466,
  "heart": 0xeb05,
  "hexagon": 0xf4db,
  "history": 0xea82,
  "home": 0xeb06,
  "hourglass": 0xedcf,
  "house": 0xeb06,
  "i-circle": 0xea74,
  "image": 0xec56,
  "image-square": 0xf2dc,
  "inbox": 0xeb09,
  "infinity": 0xed8e,
  "info": 0xea74,
  "inspect": 0xebd1,
  "issue": 0xeb0c,
  "issue-closed": 0xedba,
  "issue-draft": 0xebd9,
  "issues": 0xedbc,
  "joystick": 0xf467,
  "json": 0xeb0f,
  "kebab-horizontal": 0xea7c,
  "kebab-vertical": 0xeb10,
  "key": 0xeb11,
  "keyboard": 0xedac,
  "keyboard-tab": 0xec3c,
  "laptop": 0xedd2,
  "layers": 0xebd2,
  "layout-dialog": 0xf58f,
  "layout-empty": 0xf590,
  "layout-floating-window": 0xf591,
  "layout-panel-bottom": 0xec01,
  "layout-panel-bottom-dock": 0xec49,
  "layout-panel-bottom-on": 0xebf2,
  "layout-panel-bottom-undock": 0xf2dd,
  "layout-panel-off": 0xec01,
  "layout-sidebar-left": 0xec02,
  "layout-sidebar-left-dock": 0xec4a,
  "layout-sidebar-left-off": 0xec02,
  "layout-sidebar-left-on": 0xebf3,
  "layout-sidebar-left-undock": 0xf23a,
  "layout-sidebar-right": 0xec00,
  "layout-sidebar-right-dock": 0xec4b,
  "layout-sidebar-right-off": 0xec00,
  "layout-sidebar-right-on": 0xebf4,
  "layout-sidebar-right-undock": 0xf23b,
  "layout-split-horizontal": 0xec5c,
  "layout-split-horizontal-dashed": 0xec5b,
  "layout-split-horizontal-right-dock": 0xf305,
  "layout-split-horizontal-right-undock": 0xf306,
  "layout-split-vertical": 0xeb57,
  "leaf": 0xf468,
  "lego": 0xf469,
  "library": 0xeb9c,
  "lightbulb": 0xea61,
  "lightbulb-sparkle": 0xec10,
  "lightning": 0xedaa,
  "link": 0xeb15,
  "link-external": 0xede6,
  "list-bullets": 0xeda5,
  "list-checks": 0xeab3,
  "list-filter": 0xeb83,
  "list-ordered": 0xeb16,
  "list-todo": 0xedd0,
  "list-todo-subtask": 0xf425,
  "list-x": 0xeabf,
  "loading": 0xedca,
  "location": 0xeb1a,
  "lock": 0xea75,
  "lock-locked": 0xea75,
  "lock-unlocked": 0xeb74,
  "logo-azure": 0xebd8,
  "logo-azure-devops": 0xebe8,
  "logo-figma": 0xf42a,
  "logo-github": 0xea84,
  "logo-gitlab": 0xf42b,
  "logo-jira": 0xf4e3,
  "logo-linear": 0xf42c,
  "logo-markdown": 0xf319,
  "logo-mcp": 0xec47,
  "logo-microsoft-teams": 0xf4e4,
  "logo-notion": 0xf42d,
  "logo-python": 0xec39,
  "logo-sentry": 0xf4e5,
  "logo-slack": 0xf42e,
  "logo-vscode": 0xec29,
  "logo-vscode-insiders": 0xec2a,
  "logo-x": 0xeb72,
  "mac-mini": 0xf46a,
  "magic-wand": 0xebcf,
  "magnet": 0xebae,
  "magnifying-glass": 0xea6d,
  "magnifying-glass-fuzzy": 0xec0d,
  "magnifying-glass-minus": 0xeb82,
  "magnifying-glass-plus": 0xeb81,
  "magnifying-glass-slash-circle": 0xeb4e,
  "magnifying-glass-sparkle": 0xec50,
  "magnifyingGlass": 0xea6d,
  "magnifyingGlass-minus": 0xeb82,
  "magnifyingGlass-plus": 0xeb81,
  "magnifyingGlass-slash-circle": 0xeb4e,
  "mail": 0xeb1c,
  "map": 0xec05,
  "map-pin": 0xeb1a,
  "mark-github": 0xea84,
  "markdown": 0xeb1d,
  "mask-happy": 0xf46b,
  "masks-happy": 0xf46c,
  "mcp": 0xec47,
  "megaphone": 0xeb1e,
  "mention": 0xec55,
  "menu": 0xeb94,
  "merge": 0xebab,
  "mic": 0xec12,
  "microscope": 0xea79,
  "minus": 0xeb3b,
  "minus-circle": 0xf2de,
  "minus-small": 0xf46d,
  "mobile": 0xeadb,
  "moon": 0xf2df,
  "moon-sparkle": 0xf46e,
  "moon-z": 0xf46f,
  "more": 0xea7c,
  "music": 0xec1b,
  "mute": 0xeb24,
  "new-file": 0xed8d,
  "new-folder": 0xea80,
  "newspaper": 0xf470,
  "note": 0xeb26,
  "one-circle": 0xf420,
  "organization": 0xea7e,
  "organization-filled": 0xea7e,
  "owl": 0xf542,
  "package": 0xeb29,
  "package-zipper": 0xf48d,
  "paint-roller": 0xf471,
  "palette": 0xf472,
  "paperclip": 0xec54,
  "paperplane": 0xec0f,
  "paragraph": 0xf2e1,
  "pass": 0xedba,
  "pause": 0xf35c,
  "pause-circle": 0xf2e2,
  "paw": 0xf473,
  "pen-nib": 0xf2e3,
  "pencil": 0xea73,
  "pencil-square": 0xeddd,
  "pentagon": 0xf4dd,
  "people": 0xea7e,
  "people-3": 0xf474,
  "percent": 0xec33,
  "person": 0xea67,
  "person-add": 0xebcd,
  "person-chat-bubble": 0xeb96,
  "person-circle": 0xeb99,
  "person-follow": 0xebcd,
  "person-plus": 0xebcd,
  "piano": 0xec1a,
  "pie-chart": 0xebe4,
  "pilcrow": 0xeb7d,
  "pin": 0xeb2b,
  "pin-slash": 0xf40b,
  "pipe": 0xf530,
  "plan": 0xf2e4,
  "plane": 0xf475,
  "play": 0xf35a,
  "play-bug": 0xeb91,
  "play-circle": 0xeba6,
  "play-slow": 0xf421,
  "play-super-fast": 0xf422,
  "playback-loop": 0xf40d,
  "plays-bug": 0xebdc,
  "plug": 0xeb2d,
  "plug-slash": 0xead0,
  "plus": 0xea60,
  "plus-circle": 0xf232,
  "plus-minus": 0xf302,
  "pointer-arrow": 0xec57,
  "pug": 0xf564,
  "pulse": 0xeb31,
  "puzzle-piece": 0xf476,
  "question": 0xf2e5,
  "question-circle": 0xeb32,
  "quote": 0xeb33,
  "radar": 0xf477,
  "radio-tower": 0xeb34,
  "rect-magnifying-glass": 0xf351,
  "rect-magnifyingGlass": 0xf351,
  "redo": 0xeb37,
  "refresh": 0xeb37,
  "regex": 0xeb38,
  "remote-control": 0xf589,
  "remove": 0xeb3b,
  "remove-close": 0xed82,
  "replace": 0xf351,
  "replace-all": 0xf351,
  "report": 0xeb42,
  "return": 0xebea,
  "review": 0xf2e7,
  "robot": 0xec20,
  "rocket": 0xeb44,
  "rocking-chair": 0xf478,
  "rss": 0xeb47,
  "ruler": 0xea96,
  "rules": 0xf414,
  "run": 0xf35a,
  "satellite": 0xf479,
  "scales": 0xeb12,
  "seal": 0xf2e8,
  "seal-check": 0xeb77,
  "seal-question": 0xeb76,
  "search": 0xea6d,
  "search-stop": 0xeb4e,
  "send": 0xec0f,
  "server": 0xf48f,
  "servers": 0xeb50,
  "settings": 0xeb52,
  "settings-gear": 0xeaf8,
  "shapes-square-circle": 0xf47a,
  "share": 0xec25,
  "shield": 0xeb53,
  "shield-check": 0xebc1,
  "shield-question": 0xebc3,
  "shield-x": 0xebc2,
  "shoe-fast": 0xf47b,
  "shopping-bag": 0xf47c,
  "shopping-basket": 0xf47d,
  "signal": 0xf47e,
  "skills": 0xec10,
  "skills-capability": 0xec10,
  "slash-circle": 0xeabd,
  "sliders": 0xeb52,
  "smartwatch": 0xf2e9,
  "smiley-happy": 0xf234,
  "smiley-happy-square": 0xf47f,
  "smiley-neutral": 0xf235,
  "smiley-plus": 0xeb35,
  "smiley-sad": 0xf233,
  "snowflake": 0xf480,
  "soccer-ball": 0xf481,
  "sort-ascending": 0xf2ea,
  "sort-descending": 0xf2eb,
  "source-control": 0xedb4,
  "sparkle": 0xec10,
  "sparkles": 0xec10,
  "speaker-hifi": 0xf482,
  "speaker-waves": 0xeb75,
  "speaker-x": 0xeb24,
  "spinner": 0xedca,
  "split": 0xf42f,
  "split-horizontal": 0xec5c,
  "split-vertical": 0xeb57,
  "sprint": 0xf426,
  "square": 0xea72,
  "square-dashed": 0xf58e,
  "square-dot": 0xf423,
  "squares": 0xeabb,
  "squares-minus": 0xeac5,
  "squares-plus": 0xeb95,
  "squares-x": 0xeac1,
  "stack": 0xebd2,
  "star": 0xea6a,
  "star-empty": 0xea6a,
  "star-full": 0xeb59,
  "status-done": 0xedba,
  "status-draft": 0xedbb,
  "status-needs-attention": 0xedbc,
  "stop": 0xf35b,
  "stop-circle": 0xeba5,
  "stopwatch": 0xf418,
  "storefront": 0xf483,
  "sun": 0xf2ed,
  "swatches": 0xf484,
  "symbol-folder": 0xea83,
  "sync": 0xea77,
  "t-shirt": 0xf485,
  "table": 0xebb7,
  "tabs": 0xf2be,
  "tag": 0xea66,
  "tags-chevron-down": 0xf57e,
  "tags-chevron-left": 0xf580,
  "tags-chevron-right": 0xf582,
  "tags-chevron-up": 0xf584,
  "target": 0xebf8,
  "terminal": 0xf50e,
  "terminal-rectangle": 0xea85,
  "text-aa": 0xeab1,
  "text-ab": 0xeb2e,
  "text-b": 0xeaa3,
  "text-c": 0xf4ce,
  "text-d": 0xf4cc,
  "text-italic": 0xeb0d,
  "text-j": 0xf4f7,
  "text-r": 0xf4d1,
  "text-s": 0xf524,
  "text-strikethrough": 0xf525,
  "text-t": 0xf2ee,
  "text-t-square": 0xf2c1,
  "text-tt": 0xeb69,
  "text-y": 0xf4df,
  "thinking-high": 0xf427,
  "thinking-low": 0xf428,
  "thinking-medium": 0xf429,
  "threads-parallel": 0xf40e,
  "threads-single": 0xf40f,
  "three-bars": 0xeb6a,
  "thumbs-down": 0xed96,
  "thumbs-up": 0xed97,
  "thumbsdown": 0xed96,
  "thumbsup": 0xed97,
  "traffic-cone": 0xf34d,
  "trafficCone": 0xf34d,
  "trash": 0xea81,
  "trashcan": 0xea81,
  "tray": 0xeb09,
  "treasure-chest": 0xf486,
  "trending-down": 0xf487,
  "trending-up": 0xf488,
  "triangle-small-down": 0xeb6e,
  "triangle-small-left": 0xeb6f,
  "triangle-small-right": 0xeb70,
  "triangle-small-up": 0xeb71,
  "twig": 0xf503,
  "unfold-dashed": 0xede8,
  "unlock": 0xeb74,
  "unmute": 0xeb75,
  "unverified": 0xeb76,
  "vault": 0xf489,
  "verified": 0xeb77,
  "versions": 0xeb78,
  "video-camera": 0xead9,
  "vm": 0xea7a,
  "vr": 0xf48a,
  "vr-headset": 0xf562,
  "vr-headset-head": 0xf563,
  "wallet": 0xf48b,
  "wand": 0xec10,
  "warning": 0xea6c,
  "watch": 0xeb7c,
  "waveform": 0xf48c,
  "whole-word": 0xeb7e,
  "window": 0xeb7f,
  "window-pointer-arrow": 0xebd1,
  "windows": 0xf2bf,
  "wrench": 0xeb6d,
  "x": 0xed82,
  "x-circle": 0xea87,
  "yarn": 0xf513,
  "zap": 0xec10,
  "zipper": 0xf48d,
  "zoom-in": 0xeb81,
  "zoom-out": 0xeb82,
  "zzz": 0xf48e,
} as const;

export const SAND_ICON_FILLED_CODE_POINTS = {
  "account": 0xeb99,
  "add": 0xf3e5,
  "agent": 0xf413,
  "agent-circle": 0xf430,
  "agent-square": 0xf431,
  "agents": 0xf432,
  "agents-swarm": 0xf412,
  "alarm-clock": 0xf58c,
  "alert": 0xea6c,
  "archive": 0xea98,
  "army-base": 0xf433,
  "arrow-block-down": 0xf35d,
  "arrow-block-left": 0xf35e,
  "arrow-block-line-down": 0xf56f,
  "arrow-block-line-left": 0xf571,
  "arrow-block-line-right": 0xf573,
  "arrow-block-line-up": 0xf575,
  "arrow-block-right": 0xf35f,
  "arrow-block-up": 0xf360,
  "arrow-bracket-from-down": 0xf34e,
  "arrow-bracket-from-left": 0xf34f,
  "arrow-bracket-from-right": 0xf359,
  "arrow-bracket-from-up": 0xec28,
  "arrow-bracket-from-up-dashed": 0xec27,
  "arrow-bracket-to-down": 0xf4e1,
  "arrow-bracket-to-left": 0xf358,
  "arrow-bracket-to-right": 0xf357,
  "arrow-bracket-to-up": 0xf356,
  "arrow-ccw": 0xead2,
  "arrow-circle-down": 0xf361,
  "arrow-circle-left": 0xf362,
  "arrow-circle-right": 0xf363,
  "arrow-circle-up": 0xf364,
  "arrow-cw": 0xeb37,
  "arrow-down": 0xf365,
  "arrow-left": 0xf368,
  "arrow-left-down": 0xf366,
  "arrow-left-up": 0xf367,
  "arrow-right": 0xf36b,
  "arrow-right-down": 0xf369,
  "arrow-right-up": 0xf36a,
  "arrow-square-down": 0xf36c,
  "arrow-square-from-down": 0xf355,
  "arrow-square-from-left": 0xf354,
  "arrow-square-from-right": 0xea6e,
  "arrow-square-from-up": 0xebac,
  "arrow-square-left": 0xf36f,
  "arrow-square-left-down": 0xf36d,
  "arrow-square-left-top": 0xf36e,
  "arrow-square-left-up": 0xf36e,
  "arrow-square-right": 0xf372,
  "arrow-square-right-down": 0xf370,
  "arrow-square-right-top": 0xf371,
  "arrow-square-right-up": 0xf371,
  "arrow-square-to-down": 0xedae,
  "arrow-square-to-left": 0xf353,
  "arrow-square-to-right": 0xea6f,
  "arrow-square-to-up": 0xf352,
  "arrow-square-up": 0xf373,
  "arrow-swap": 0xebcb,
  "arrow-u-up-left": 0xed84,
  "arrow-u-up-right": 0xf31e,
  "arrow-up": 0xf374,
  "arrows-both-horizontal": 0xea99,
  "arrows-both-vertical": 0xf2ca,
  "arrows-ccw": 0xf30f,
  "arrows-ccw-angular": 0xf2cc,
  "arrows-contract": 0xf310,
  "arrows-contract-simple": 0xf2cd,
  "arrows-cw": 0xea77,
  "arrows-down-up": 0xf2ce,
  "arrows-expand": 0xf311,
  "arrows-expand-simple": 0xf2cf,
  "arrows-left-right": 0xebcb,
  "arrows-out-cardinal": 0xeb22,
  "asterisk": 0xedbf,
  "at": 0xf375,
  "atom": 0xf4bc,
  "bandaid": 0xf435,
  "banknote": 0xf500,
  "banknotes-stack": 0xf436,
  "barbell": 0xf437,
  "basketball": 0xf438,
  "beach-umbrella": 0xf439,
  "beaker": 0xea79,
  "beaker-stop": 0xebe1,
  "beehouse": 0xf43a,
  "bell": 0xeaa2,
  "bell-dot": 0xeb9a,
  "bell-slash": 0xec08,
  "binary": 0xf556,
  "binoculars": 0xeb68,
  "bluetooth": 0xf43b,
  "board-kanban": 0xf376,
  "book": 0xf414,
  "book-open": 0xf377,
  "bookmark": 0xf378,
  "books": 0xeb9c,
  "bowtie": 0xf4f3,
  "bracket": 0xf555,
  "bracket-dot": 0xebe5,
  "bracket-error": 0xebe6,
  "brackets-curly": 0xf555,
  "brackets-curly-dot": 0xebe5,
  "brackets-curly-x": 0xebe6,
  "brackets-square": 0xea8a,
  "brain": 0xed87,
  "brain-hourglass": 0xf43c,
  "brain-simple": 0xf43d,
  "brain-simplest": 0xf43e,
  "brain-slash": 0xf43f,
  "briefcase": 0xeaac,
  "browser": 0xf379,
  "browsers": 0xf37a,
  "brush": 0xedb3,
  "bug": 0xf37b,
  "bugbot": 0xec59,
  "building": 0xf440,
  "buildings": 0xf441,
  "bullseye": 0xebf8,
  "calculator": 0xf442,
  "calendar": 0xeab0,
  "calendar-hourglass": 0xf415,
  "camera": 0xf37c,
  "car": 0xf443,
  "cardholder": 0xf444,
  "castle": 0xf445,
  "cd": 0xf4b5,
  "chart-bars": 0xeb03,
  "chart-line": 0xebe2,
  "chart-pie": 0xf37d,
  "chart-pyramid": 0xf419,
  "chart-scatter": 0xebe3,
  "chat-bubble": 0xf381,
  "chat-bubble-chevrons-left-right": 0xf37e,
  "chat-bubble-ellipsis": 0xf37f,
  "chat-bubble-exclamation": 0xeb42,
  "chat-bubble-pencil": 0xedc3,
  "chat-bubble-question": 0xf380,
  "chat-bubbles": 0xf382,
  "chat-bubbles-grid": 0xf424,
  "chatBubble": 0xf381,
  "chatBubble-ellipsis": 0xf37f,
  "chatBubble-exclamation": 0xeb42,
  "chatBubble-question": 0xf380,
  "chatBubbles": 0xf382,
  "check": 0xf385,
  "check-circle": 0xf383,
  "check-square": 0xf384,
  "checks": 0xebb1,
  "chef-hat": 0xf447,
  "chess-king": 0xf448,
  "chess-tower": 0xf449,
  "chevron-circle-down": 0xf577,
  "chevron-circle-left": 0xf579,
  "chevron-circle-right": 0xf57b,
  "chevron-circle-up": 0xf57d,
  "chevron-down": 0xf387,
  "chevron-down-small": 0xf386,
  "chevron-left": 0xf389,
  "chevron-left-small": 0xf388,
  "chevron-right": 0xf38b,
  "chevron-right-small": 0xf38a,
  "chevron-up": 0xf38d,
  "chevron-up-small": 0xf38c,
  "chevrons-down": 0xeaf3,
  "chevrons-down-up": 0xeaf5,
  "chevrons-left": 0xedd4,
  "chevrons-left-right": 0xf2d7,
  "chevrons-right": 0xf31d,
  "chevrons-right-dotted-left": 0xedc6,
  "chevrons-up": 0xeaf4,
  "chevrons-up-down": 0xedcb,
  "chip": 0xec19,
  "chip-simple": 0xf41a,
  "circle": 0xf38f,
  "circle-circle": 0xf38e,
  "circle-dashed": 0xedbb,
  "circles": 0xf390,
  "circles-check": 0xec2e,
  "clipboard": 0xedc9,
  "clock": 0xf391,
  "clone": 0xf399,
  "close": 0xf409,
  "cloud": 0xf392,
  "cloud-arrow-down": 0xeac2,
  "cloud-arrow-up": 0xeac3,
  "cloud-download": 0xeac2,
  "cloud-upload": 0xeac3,
  "code": 0xf44a,
  "code-brackets": 0xea8a,
  "code-simple": 0xf4c1,
  "cog": 0xf393,
  "collection": 0xf395,
  "collection-plus": 0xf394,
  "color-mode": 0xf396,
  "command": 0xf397,
  "comment": 0xea6b,
  "comment-dashed": 0xec0e,
  "comment-discussion": 0xf382,
  "comment-dot": 0xec0a,
  "comments": 0xeac7,
  "compass": 0xf398,
  "compass-check": 0xebd7,
  "compass-dot": 0xebd6,
  "conversation": 0xf382,
  "cookie": 0xf4f6,
  "copilot": 0xf3f4,
  "copy": 0xf399,
  "corners-in": 0xeb4d,
  "corners-out": 0xeb4c,
  "corners-out-check": 0xf2da,
  "corners-out-sparkle": 0xf44d,
  "cost-high": 0xf41b,
  "cost-low": 0xf41c,
  "cost-medium": 0xf41d,
  "credit-card": 0xf39a,
  "cross-medical": 0xf44e,
  "crosshair": 0xf44f,
  "crown": 0xf53f,
  "crystal-ball": 0xf450,
  "cube": 0xf39d,
  "cube-coordinates": 0xf451,
  "cube-nodes": 0xf39b,
  "cube-transparent": 0xf39c,
  "currency-btc": 0xf452,
  "currency-dollar": 0xf4c6,
  "currency-eth": 0xf4b6,
  "cursor-logo": 0xf39e,
  "cursor-text": 0xf304,
  "cutlery": 0xf455,
  "cylinder": 0xf456,
  "dashboard": 0xf457,
  "database": 0xf39f,
  "database-network": 0xf458,
  "debug-pause": 0xead1,
  "debug-restart": 0xead2,
  "debug-start": 0xeb2c,
  "debug-stop": 0xf3fe,
  "deckchair-umbrella": 0xf459,
  "desktop-download": 0xeac2,
  "device-camera": 0xf37c,
  "device-camera-video": 0xf405,
  "device-desktop": 0xf3a8,
  "device-mobile": 0xf3da,
  "diagram": 0xf41e,
  "diff": 0xf3a7,
  "diff-added": 0xf3a0,
  "diff-ignored": 0xf3a1,
  "diff-modified": 0xf3a2,
  "diff-multiple": 0xf3a3,
  "diff-removed": 0xf3a4,
  "diff-renamed": 0xf3a5,
  "diff-single": 0xf3a6,
  "diff-single-arrow-right-up": 0xec0b,
  "diff-single-dot": 0xec0c,
  "discard": 0xf409,
  "display": 0xf3a8,
  "display-check": 0xeb79,
  "display-circle": 0xeb7a,
  "display-connect": 0xeba9,
  "display-play": 0xeb7b,
  "display-waves": 0xf586,
  "displays": 0xf588,
  "dots-3-horizontal": 0xea7c,
  "dots-3-vertical": 0xeb10,
  "drop": 0xf4f5,
  "easel": 0xf45a,
  "edit": 0xea73,
  "elephant": 0xf4d6,
  "ellipsis": 0xea7c,
  "envelope": 0xf3a9,
  "envelope-open": 0xeb1b,
  "eraser": 0xeda0,
  "error": 0xf408,
  "exclamation-circle": 0xf3aa,
  "exclamation-triangle": 0xea6c,
  "execution-parallel": 0xf410,
  "execution-sequential": 0xf411,
  "extensions": 0xf3ab,
  "eye": 0xf3ac,
  "eye-closed": 0xf338,
  "eye-slash": 0xeae7,
  "fast-backward": 0xf416,
  "fast-forward": 0xf417,
  "feedback": 0xf37f,
  "file": 0xf3ad,
  "file-add": 0xed8d,
  "file-arrow-right-up": 0xeaee,
  "file-binary": 0xf3ad,
  "file-chevrons-left-right": 0xeae9,
  "file-code": 0xf3ad,
  "file-directory": 0xf3b2,
  "file-directory-create": 0xea80,
  "file-image": 0xeaea,
  "file-list": 0xec53,
  "file-lock": 0xeafa,
  "file-media": 0xeaea,
  "file-pdf": 0xeaeb,
  "file-plus": 0xed8d,
  "file-text": 0xf4bd,
  "file-type-adobe-illustrator": 0xf4ed,
  "file-type-adobe-photoshop": 0xf4eb,
  "file-type-babel": 0xf53b,
  "file-type-bazel": 0xf522,
  "file-type-bevy": 0xf527,
  "file-type-bicep": 0xf4fd,
  "file-type-biomejs": 0xf593,
  "file-type-bower": 0xf567,
  "file-type-bun": 0xf595,
  "file-type-c-plus-plus": 0xf50f,
  "file-type-c-sharp": 0xf510,
  "file-type-clojure": 0xf4d4,
  "file-type-crystal": 0xf4d8,
  "file-type-cuda": 0xf541,
  "file-type-dart": 0xf597,
  "file-type-docker": 0xf4a6,
  "file-type-ejs": 0xf54d,
  "file-type-elixir": 0xf4ef,
  "file-type-eslint": 0xf535,
  "file-type-f-sharp": 0xf4da,
  "file-type-firebase": 0xf4fb,
  "file-type-geckodriver": 0xf516,
  "file-type-git-meta": 0xf4a7,
  "file-type-go": 0xf55b,
  "file-type-godot": 0xf51e,
  "file-type-grails": 0xf502,
  "file-type-graphql": 0xf4a8,
  "file-type-groovy": 0xf537,
  "file-type-grunt": 0xf569,
  "file-type-gulp": 0xf547,
  "file-type-haml": 0xf55f,
  "file-type-handlebars": 0xf554,
  "file-type-haskell": 0xf4e9,
  "file-type-ionic": 0xf4a9,
  "file-type-java": 0xf4f9,
  "file-type-javascript": 0xf557,
  "file-type-julia": 0xf4aa,
  "file-type-jupyter": 0xf512,
  "file-type-karma": 0xf4c2,
  "file-type-kotlin": 0xf4ab,
  "file-type-latex": 0xf50a,
  "file-type-liquid": 0xf53d,
  "file-type-maven": 0xf551,
  "file-type-mustache": 0xf50c,
  "file-type-npm": 0xf518,
  "file-type-nunjucks": 0xf533,
  "file-type-ocaml": 0xf56b,
  "file-type-odata": 0xf506,
  "file-type-pdf": 0xf55c,
  "file-type-perl": 0xf56d,
  "file-type-platformio": 0xf52b,
  "file-type-powershell": 0xf4f1,
  "file-type-prettier": 0xf599,
  "file-type-prisma": 0xf52f,
  "file-type-prolog": 0xf545,
  "file-type-puppet": 0xf4e7,
  "file-type-python": 0xf4ac,
  "file-type-reason": 0xf549,
  "file-type-rescript": 0xf52d,
  "file-type-rollup": 0xf4ad,
  "file-type-rust": 0xf4ae,
  "file-type-sass": 0xf4ff,
  "file-type-sbt": 0xf54b,
  "file-type-scala": 0xf4c9,
  "file-type-slim": 0xf54f,
  "file-type-stylus": 0xf529,
  "file-type-sublime": 0xf508,
  "file-type-svelte": 0xf559,
  "file-type-swift": 0xf4af,
  "file-type-terraform": 0xf4b0,
  "file-type-typescript": 0xf558,
  "file-type-vala": 0xf51c,
  "file-type-vite": 0xf4b1,
  "file-type-vsc": 0xf51a,
  "file-type-vue": 0xf4b2,
  "file-type-web-assembly": 0xf4cb,
  "file-type-webpack": 0xf4b3,
  "file-type-windows": 0xf4b4,
  "file-type-yarn": 0xf520,
  "file-type-zig": 0xf539,
  "file-zip": 0xf3ad,
  "files": 0xf3ae,
  "film-reel": 0xf45c,
  "film-strip": 0xf4b7,
  "filter": 0xeaf1,
  "flag": 0xf3af,
  "flag-hill": 0xeb20,
  "flame": 0xeaf2,
  "flask": 0xea79,
  "flask-slash-circle": 0xebe1,
  "floppy-disc": 0xf3b0,
  "focus-window": 0xf3b1,
  "fold-dashed": 0xede9,
  "folder": 0xf3b2,
  "folder-active": 0xeaf6,
  "folder-arrow-right-up": 0xeaed,
  "folder-check": 0xeaf6,
  "folder-dashed": 0xf58d,
  "folder-library": 0xebdf,
  "folder-open": 0xeaf7,
  "folder-opened": 0xf3b2,
  "folder-plus": 0xea80,
  "folders": 0xeaec,
  "fork": 0xf41f,
  "funnel": 0xeaf1,
  "funnel-simple": 0xeb83,
  "game-controller": 0xf45e,
  "game-controller-retro": 0xf45f,
  "gauge": 0xeacd,
  "gear": 0xf393,
  "gem": 0xf3b3,
  "gift": 0xeaf9,
  "git-branch": 0xf3b4,
  "git-commit": 0xf3b6,
  "git-commit-horizontal": 0xf3b5,
  "git-compare": 0xf3b7,
  "git-fetch": 0xec1d,
  "git-fork": 0xf3b8,
  "git-merge": 0xf3b9,
  "git-pull": 0xf3bf,
  "git-pull-request": 0xf3be,
  "git-pull-request-closed": 0xf3ba,
  "git-pull-request-create": 0xf3bb,
  "git-pull-request-done": 0xf3bc,
  "git-pull-request-draft": 0xf3bd,
  "git-push": 0xf3c0,
  "github": 0xea84,
  "github-actions": 0xeaff,
  "globe": 0xf3c1,
  "graduation-cap": 0xeb21,
  "graph": 0xeb03,
  "graph-line": 0xebe2,
  "graph-scatter": 0xebe3,
  "grid": 0xf460,
  "grid-plus": 0xf461,
  "grid-sparkle": 0xf462,
  "gripper": 0xeb04,
  "hamburger": 0xf463,
  "hammer": 0xedab,
  "hash": 0xf4c5,
  "hat": 0xf464,
  "headphones": 0xf465,
  "headset": 0xf466,
  "heart": 0xf3c2,
  "hexagon": 0xf4dc,
  "history": 0xea82,
  "home": 0xeb06,
  "hourglass": 0xedcf,
  "house": 0xeb06,
  "i-circle": 0xf3c3,
  "image": 0xf3c5,
  "image-square": 0xf3c4,
  "inbox": 0xeb09,
  "infinity": 0xed8e,
  "info": 0xf3c3,
  "inspect": 0xebd1,
  "issue": 0xf3c6,
  "issue-closed": 0xf383,
  "issue-draft": 0xebd9,
  "issues": 0xf3aa,
  "joystick": 0xf467,
  "json": 0xf555,
  "kebab-horizontal": 0xea7c,
  "kebab-vertical": 0xeb10,
  "key": 0xeb11,
  "keyboard": 0xedac,
  "keyboard-tab": 0xf3c7,
  "laptop": 0xf3c9,
  "layers": 0xf3fc,
  "layout-dialog": 0xf58f,
  "layout-empty": 0xf590,
  "layout-floating-window": 0xf591,
  "layout-panel-bottom": 0xf3ca,
  "layout-panel-bottom-dock": 0xec49,
  "layout-panel-bottom-on": 0xebf2,
  "layout-panel-bottom-undock": 0xf2dd,
  "layout-panel-off": 0xf3ca,
  "layout-sidebar-left": 0xf3cb,
  "layout-sidebar-left-dock": 0xec4a,
  "layout-sidebar-left-off": 0xf3cb,
  "layout-sidebar-left-on": 0xebf3,
  "layout-sidebar-left-undock": 0xf23a,
  "layout-sidebar-right": 0xf3cc,
  "layout-sidebar-right-dock": 0xec4b,
  "layout-sidebar-right-off": 0xf3cc,
  "layout-sidebar-right-on": 0xebf4,
  "layout-sidebar-right-undock": 0xf23b,
  "layout-split-horizontal": 0xf3cd,
  "layout-split-horizontal-dashed": 0xec5b,
  "layout-split-horizontal-right-dock": 0xf305,
  "layout-split-horizontal-right-undock": 0xf306,
  "layout-split-vertical": 0xf3ce,
  "leaf": 0xf468,
  "lego": 0xf469,
  "library": 0xeb9c,
  "lightbulb": 0xf50d,
  "lightbulb-sparkle": 0xf3f4,
  "lightning": 0xf3cf,
  "link": 0xeb15,
  "link-external": 0xf3b1,
  "list-bullets": 0xeda5,
  "list-checks": 0xeab3,
  "list-filter": 0xeb83,
  "list-ordered": 0xeb16,
  "list-todo": 0xf3d0,
  "list-todo-subtask": 0xf425,
  "list-x": 0xeabf,
  "loading": 0xedca,
  "location": 0xf3d6,
  "lock": 0xf3d1,
  "lock-locked": 0xf3d1,
  "lock-unlocked": 0xf3d2,
  "logo-azure": 0xebd8,
  "logo-azure-devops": 0xebe8,
  "logo-figma": 0xf42a,
  "logo-github": 0xea84,
  "logo-gitlab": 0xf42b,
  "logo-jira": 0xf4e3,
  "logo-linear": 0xf42c,
  "logo-markdown": 0xf319,
  "logo-mcp": 0xec47,
  "logo-microsoft-teams": 0xf4e4,
  "logo-notion": 0xf42d,
  "logo-python": 0xec39,
  "logo-sentry": 0xf4e5,
  "logo-slack": 0xf42e,
  "logo-vscode": 0xec29,
  "logo-vscode-insiders": 0xec2a,
  "logo-x": 0xeb72,
  "mac-mini": 0xf46a,
  "magic-wand": 0xebcf,
  "magnet": 0xebae,
  "magnifying-glass": 0xf3d5,
  "magnifying-glass-fuzzy": 0xec0d,
  "magnifying-glass-minus": 0xf3d3,
  "magnifying-glass-plus": 0xf3d4,
  "magnifying-glass-slash-circle": 0xeb4e,
  "magnifying-glass-sparkle": 0xec50,
  "magnifyingGlass": 0xf3d5,
  "magnifyingGlass-minus": 0xf3d3,
  "magnifyingGlass-plus": 0xf3d4,
  "magnifyingGlass-slash-circle": 0xeb4e,
  "mail": 0xf3a9,
  "map": 0xec05,
  "map-pin": 0xf3d6,
  "mark-github": 0xea84,
  "markdown": 0xf55d,
  "mask-happy": 0xf46b,
  "masks-happy": 0xf46c,
  "mcp": 0xec47,
  "megaphone": 0xeb1e,
  "mention": 0xf375,
  "menu": 0xeb94,
  "merge": 0xebab,
  "mic": 0xf3d7,
  "microscope": 0xea79,
  "minus": 0xf3d9,
  "minus-circle": 0xf3d8,
  "minus-small": 0xf46d,
  "mobile": 0xf3da,
  "moon": 0xf3db,
  "moon-sparkle": 0xf46e,
  "moon-z": 0xf46f,
  "more": 0xea7c,
  "music": 0xf3dc,
  "mute": 0xf3f6,
  "new-file": 0xed8d,
  "new-folder": 0xea80,
  "newspaper": 0xf470,
  "note": 0xeb26,
  "one-circle": 0xf420,
  "organization": 0xea7e,
  "organization-filled": 0xea7e,
  "owl": 0xf543,
  "package": 0xf4e2,
  "package-zipper": 0xf552,
  "paint-roller": 0xf471,
  "palette": 0xf4b8,
  "paperclip": 0xec54,
  "paperplane": 0xf3dd,
  "paragraph": 0xf4c3,
  "pass": 0xf383,
  "pause": 0xead1,
  "pause-circle": 0xf3de,
  "paw": 0xf473,
  "pen-nib": 0xf2e3,
  "pencil": 0xea73,
  "pencil-square": 0xeddd,
  "pentagon": 0xf4de,
  "people": 0xea7e,
  "people-3": 0xf474,
  "percent": 0xec33,
  "person": 0xf3df,
  "person-add": 0xebcd,
  "person-chat-bubble": 0xeb96,
  "person-circle": 0xeb99,
  "person-follow": 0xebcd,
  "person-plus": 0xebcd,
  "piano": 0xec1a,
  "pie-chart": 0xf37d,
  "pilcrow": 0xeb7d,
  "pin": 0xf3e0,
  "pin-slash": 0xf40b,
  "pipe": 0xf531,
  "plan": 0xf3e1,
  "plane": 0xf475,
  "play": 0xeb2c,
  "play-bug": 0xeb91,
  "play-circle": 0xf3e2,
  "play-slow": 0xf421,
  "play-super-fast": 0xf422,
  "playback-loop": 0xf40d,
  "plays-bug": 0xebdc,
  "plug": 0xf3e3,
  "plug-slash": 0xead0,
  "plus": 0xf3e5,
  "plus-circle": 0xf3e4,
  "plus-minus": 0xf302,
  "pointer-arrow": 0xf3e6,
  "pug": 0xf565,
  "pulse": 0xeb31,
  "puzzle-piece": 0xf476,
  "question": 0xf2e5,
  "question-circle": 0xf3e7,
  "quote": 0xeb33,
  "radar": 0xf477,
  "radio-tower": 0xeb34,
  "rect-magnifying-glass": 0xf351,
  "rect-magnifyingGlass": 0xf351,
  "redo": 0xeb37,
  "refresh": 0xeb37,
  "regex": 0xeb38,
  "remote-control": 0xf58a,
  "remove": 0xf3d9,
  "remove-close": 0xf409,
  "replace": 0xf351,
  "replace-all": 0xf351,
  "report": 0xeb42,
  "return": 0xebea,
  "review": 0xf2e7,
  "robot": 0xf3e8,
  "rocket": 0xeb44,
  "rocking-chair": 0xf478,
  "rss": 0xeb47,
  "ruler": 0xea96,
  "rules": 0xf414,
  "run": 0xeb2c,
  "satellite": 0xf479,
  "scales": 0xeb12,
  "seal": 0xf3ea,
  "seal-check": 0xf3e9,
  "seal-question": 0xeb76,
  "search": 0xf3d5,
  "search-stop": 0xeb4e,
  "send": 0xf3dd,
  "server": 0xf48f,
  "servers": 0xeb50,
  "settings": 0xf3f0,
  "settings-gear": 0xf393,
  "shapes-square-circle": 0xf4b9,
  "share": 0xec25,
  "shield": 0xf3ee,
  "shield-check": 0xf3eb,
  "shield-question": 0xf3ec,
  "shield-x": 0xf3ed,
  "shoe-fast": 0xf47b,
  "shopping-bag": 0xf47c,
  "shopping-basket": 0xf47d,
  "signal": 0xf47e,
  "skills": 0xf3f4,
  "skills-capability": 0xf3f4,
  "slash-circle": 0xf3ef,
  "sliders": 0xf3f0,
  "smartwatch": 0xf2e9,
  "smiley-happy": 0xf3f1,
  "smiley-happy-square": 0xf47f,
  "smiley-neutral": 0xf3f2,
  "smiley-plus": 0xeb35,
  "smiley-sad": 0xf3f3,
  "snowflake": 0xf480,
  "soccer-ball": 0xf481,
  "sort-ascending": 0xf2ea,
  "sort-descending": 0xf2eb,
  "source-control": 0xf3b4,
  "sparkle": 0xf3f4,
  "sparkles": 0xf3f4,
  "speaker-hifi": 0xf482,
  "speaker-waves": 0xf3f5,
  "speaker-x": 0xf3f6,
  "spinner": 0xedca,
  "split": 0xf42f,
  "split-horizontal": 0xf3cd,
  "split-vertical": 0xf3ce,
  "sprint": 0xf426,
  "square": 0xf3f7,
  "square-dashed": 0xf58e,
  "square-dot": 0xf423,
  "squares": 0xf3fb,
  "squares-minus": 0xf3f8,
  "squares-plus": 0xf3f9,
  "squares-x": 0xf3fa,
  "stack": 0xf3fc,
  "star": 0xf3fd,
  "star-empty": 0xf3fd,
  "star-full": 0xeb59,
  "status-done": 0xf383,
  "status-draft": 0xedbb,
  "status-needs-attention": 0xf3aa,
  "stop": 0xed86,
  "stop-circle": 0xf3fe,
  "stopwatch": 0xf418,
  "storefront": 0xf483,
  "sun": 0xf3ff,
  "swatches": 0xf484,
  "symbol-folder": 0xf3b2,
  "sync": 0xea77,
  "t-shirt": 0xf485,
  "table": 0xf4bb,
  "tabs": 0xf2be,
  "tag": 0xf400,
  "tags-chevron-down": 0xf57f,
  "tags-chevron-left": 0xf581,
  "tags-chevron-right": 0xf583,
  "tags-chevron-up": 0xf585,
  "target": 0xebf8,
  "terminal": 0xf50e,
  "terminal-rectangle": 0xf401,
  "text-aa": 0xf55a,
  "text-ab": 0xeb2e,
  "text-b": 0xeaa3,
  "text-c": 0xf4cf,
  "text-d": 0xf4cd,
  "text-italic": 0xeb0d,
  "text-j": 0xf4f8,
  "text-r": 0xf4d2,
  "text-s": 0xf524,
  "text-strikethrough": 0xf525,
  "text-t": 0xf4d0,
  "text-t-square": 0xf402,
  "text-tt": 0xeb69,
  "text-y": 0xf4e0,
  "thinking-high": 0xf427,
  "thinking-low": 0xf428,
  "thinking-medium": 0xf429,
  "threads-parallel": 0xf40e,
  "threads-single": 0xf40f,
  "three-bars": 0xeb6a,
  "thumbs-down": 0xf560,
  "thumbs-up": 0xf561,
  "thumbsdown": 0xf560,
  "thumbsup": 0xf561,
  "traffic-cone": 0xf34d,
  "trafficCone": 0xf34d,
  "trash": 0xf403,
  "trashcan": 0xf403,
  "tray": 0xeb09,
  "treasure-chest": 0xf486,
  "trending-down": 0xf487,
  "trending-up": 0xf488,
  "triangle-small-down": 0xeb6e,
  "triangle-small-left": 0xeb6f,
  "triangle-small-right": 0xeb70,
  "triangle-small-up": 0xeb71,
  "twig": 0xf504,
  "unfold-dashed": 0xede8,
  "unlock": 0xf3d2,
  "unmute": 0xf3f5,
  "unverified": 0xeb76,
  "vault": 0xf489,
  "verified": 0xf3e9,
  "versions": 0xf404,
  "video-camera": 0xf405,
  "vm": 0xf3a8,
  "vr": 0xf48a,
  "vr-headset": 0xf562,
  "vr-headset-head": 0xf563,
  "wallet": 0xf48b,
  "wand": 0xf3f4,
  "warning": 0xea6c,
  "watch": 0xeb7c,
  "waveform": 0xf4c4,
  "whole-word": 0xeb7e,
  "window": 0xf406,
  "window-pointer-arrow": 0xebd1,
  "windows": 0xf407,
  "wrench": 0xeb6d,
  "x": 0xf409,
  "x-circle": 0xf408,
  "yarn": 0xf514,
  "zap": 0xf3f4,
  "zipper": 0xf552,
  "zoom-in": 0xf3d4,
  "zoom-out": 0xf3d3,
  "zzz": 0xf48e,
} as const;

// Exact Windows renderer tables. The shared font is byte-identical, but the
// shipped Windows renderer assigns a different codepoint range to many names.
// @evidence recovered/frontend/app/assets/index-UbX-y3il.js#sha256=80464803b50f478598080bdc1b91da3996c6b74168e2351ea26f620f2ec62ba5#q5t/j5t
export const SAND_ICON_OUTLINE_CODE_POINTS_WINDOWS = {
  "account": 0xeb99,
  "add": 0xf3e5,
  "agent": 0xf413,
  "agent-circle": 0xf430,
  "agent-square": 0xf431,
  "agents": 0xf432,
  "agents-swarm": 0xf412,
  "alarm-clock": 0xf58c,
  "alert": 0xea6c,
  "archive": 0xea98,
  "army-base": 0xf433,
  "arrow-block-down": 0xf35d,
  "arrow-block-left": 0xf35e,
  "arrow-block-line-down": 0xf56f,
  "arrow-block-line-left": 0xf571,
  "arrow-block-line-right": 0xf573,
  "arrow-block-line-up": 0xf575,
  "arrow-block-right": 0xf35f,
  "arrow-block-up": 0xf360,
  "arrow-bracket-from-down": 0xf34e,
  "arrow-bracket-from-left": 0xf34f,
  "arrow-bracket-from-right": 0xf359,
  "arrow-bracket-from-up": 0xec28,
  "arrow-bracket-from-up-dashed": 0xec27,
  "arrow-bracket-to-down": 0xf4e1,
  "arrow-bracket-to-left": 0xf358,
  "arrow-bracket-to-right": 0xf357,
  "arrow-bracket-to-up": 0xf356,
  "arrow-ccw": 0xead2,
  "arrow-circle-down": 0xf361,
  "arrow-circle-left": 0xf362,
  "arrow-circle-right": 0xf363,
  "arrow-circle-up": 0xf364,
  "arrow-cw": 0xeb37,
  "arrow-down": 0xf365,
  "arrow-left": 0xf368,
  "arrow-left-down": 0xf366,
  "arrow-left-up": 0xf367,
  "arrow-right": 0xf36b,
  "arrow-right-down": 0xf369,
  "arrow-right-up": 0xf36a,
  "arrow-square-down": 0xf36c,
  "arrow-square-from-down": 0xf355,
  "arrow-square-from-left": 0xf354,
  "arrow-square-from-right": 0xea6e,
  "arrow-square-from-up": 0xebac,
  "arrow-square-left": 0xf36f,
  "arrow-square-left-down": 0xf36d,
  "arrow-square-left-top": 0xf36e,
  "arrow-square-left-up": 0xf36e,
  "arrow-square-right": 0xf372,
  "arrow-square-right-down": 0xf370,
  "arrow-square-right-top": 0xf371,
  "arrow-square-right-up": 0xf371,
  "arrow-square-to-down": 0xedae,
  "arrow-square-to-left": 0xf353,
  "arrow-square-to-right": 0xea6f,
  "arrow-square-to-up": 0xf352,
  "arrow-square-up": 0xf373,
  "arrow-swap": 0xebcb,
  "arrow-u-up-left": 0xed84,
  "arrow-u-up-right": 0xf31e,
  "arrow-up": 0xf374,
  "arrows-both-horizontal": 0xea99,
  "arrows-both-vertical": 0xf2ca,
  "arrows-ccw": 0xf30f,
  "arrows-ccw-angular": 0xf2cc,
  "arrows-contract": 0xf310,
  "arrows-contract-simple": 0xf2cd,
  "arrows-cw": 0xea77,
  "arrows-down-up": 0xf2ce,
  "arrows-expand": 0xf311,
  "arrows-expand-simple": 0xf2cf,
  "arrows-left-right": 0xebcb,
  "arrows-out-cardinal": 0xeb22,
  "asterisk": 0xedbf,
  "at": 0xf375,
  "atom": 0xf4bc,
  "bandaid": 0xf435,
  "banknote": 0xf500,
  "banknotes-stack": 0xf436,
  "barbell": 0xf437,
  "basketball": 0xf438,
  "beach-umbrella": 0xf439,
  "beaker": 0xea79,
  "beaker-stop": 0xebe1,
  "beehouse": 0xf43a,
  "bell": 0xeaa2,
  "bell-dot": 0xeb9a,
  "bell-slash": 0xec08,
  "binary": 0xf556,
  "binoculars": 0xeb68,
  "bluetooth": 0xf43b,
  "board-kanban": 0xf376,
  "book": 0xf414,
  "book-open": 0xf377,
  "bookmark": 0xf378,
  "books": 0xeb9c,
  "bowtie": 0xf4f3,
  "bracket": 0xf555,
  "bracket-dot": 0xebe5,
  "bracket-error": 0xebe6,
  "brackets-curly": 0xf555,
  "brackets-curly-dot": 0xebe5,
  "brackets-curly-x": 0xebe6,
  "brackets-square": 0xea8a,
  "brain": 0xed87,
  "brain-hourglass": 0xf43c,
  "brain-simple": 0xf43d,
  "brain-simplest": 0xf43e,
  "brain-slash": 0xf43f,
  "briefcase": 0xeaac,
  "browser": 0xf379,
  "browsers": 0xf37a,
  "brush": 0xedb3,
  "bug": 0xf37b,
  "bugbot": 0xec59,
  "building": 0xf440,
  "buildings": 0xf441,
  "bullseye": 0xebf8,
  "calculator": 0xf442,
  "calendar": 0xeab0,
  "calendar-hourglass": 0xf415,
  "camera": 0xf37c,
  "car": 0xf443,
  "cardholder": 0xf444,
  "castle": 0xf445,
  "cd": 0xf4b5,
  "chart-bars": 0xeb03,
  "chart-line": 0xebe2,
  "chart-pie": 0xf37d,
  "chart-pyramid": 0xf419,
  "chart-scatter": 0xebe3,
  "chat-bubble": 0xf381,
  "chat-bubble-chevrons-left-right": 0xf37e,
  "chat-bubble-ellipsis": 0xf37f,
  "chat-bubble-exclamation": 0xeb42,
  "chat-bubble-pencil": 0xedc3,
  "chat-bubble-question": 0xf380,
  "chat-bubbles": 0xf382,
  "chat-bubbles-grid": 0xf424,
  "chatBubble": 0xf381,
  "chatBubble-ellipsis": 0xf37f,
  "chatBubble-exclamation": 0xeb42,
  "chatBubble-question": 0xf380,
  "chatBubbles": 0xf382,
  "check": 0xf385,
  "check-circle": 0xf383,
  "check-square": 0xf384,
  "checks": 0xebb1,
  "chef-hat": 0xf447,
  "chess-king": 0xf448,
  "chess-tower": 0xf449,
  "chevron-circle-down": 0xf577,
  "chevron-circle-left": 0xf579,
  "chevron-circle-right": 0xf57b,
  "chevron-circle-up": 0xf57d,
  "chevron-down": 0xf387,
  "chevron-down-small": 0xf386,
  "chevron-left": 0xf389,
  "chevron-left-small": 0xf388,
  "chevron-right": 0xf38b,
  "chevron-right-small": 0xf38a,
  "chevron-up": 0xf38d,
  "chevron-up-small": 0xf38c,
  "chevrons-down": 0xeaf3,
  "chevrons-down-up": 0xeaf5,
  "chevrons-left": 0xedd4,
  "chevrons-left-right": 0xf2d7,
  "chevrons-right": 0xf31d,
  "chevrons-right-dotted-left": 0xedc6,
  "chevrons-up": 0xeaf4,
  "chevrons-up-down": 0xedcb,
  "chip": 0xec19,
  "chip-simple": 0xf41a,
  "circle": 0xf38f,
  "circle-circle": 0xf38e,
  "circle-dashed": 0xedbb,
  "circles": 0xf390,
  "circles-check": 0xec2e,
  "clipboard": 0xedc9,
  "clock": 0xf391,
  "clone": 0xf399,
  "close": 0xf409,
  "cloud": 0xf392,
  "cloud-arrow-down": 0xeac2,
  "cloud-arrow-up": 0xeac3,
  "cloud-download": 0xeac2,
  "cloud-upload": 0xeac3,
  "code": 0xf44a,
  "code-brackets": 0xea8a,
  "code-simple": 0xf4c1,
  "cog": 0xf393,
  "collection": 0xf395,
  "collection-plus": 0xf394,
  "color-mode": 0xf396,
  "command": 0xf397,
  "comment": 0xea6b,
  "comment-dashed": 0xec0e,
  "comment-discussion": 0xf382,
  "comment-dot": 0xec0a,
  "comments": 0xeac7,
  "compass": 0xf398,
  "compass-check": 0xebd7,
  "compass-dot": 0xebd6,
  "conversation": 0xf382,
  "cookie": 0xf4f6,
  "copilot": 0xf3f4,
  "copy": 0xf399,
  "corners-in": 0xeb4d,
  "corners-out": 0xeb4c,
  "corners-out-check": 0xf2da,
  "corners-out-sparkle": 0xf44d,
  "cost-high": 0xf41b,
  "cost-low": 0xf41c,
  "cost-medium": 0xf41d,
  "credit-card": 0xf39a,
  "cross-medical": 0xf44e,
  "crosshair": 0xf44f,
  "crown": 0xf53f,
  "crystal-ball": 0xf450,
  "cube": 0xf39d,
  "cube-coordinates": 0xf451,
  "cube-nodes": 0xf39b,
  "cube-transparent": 0xf39c,
  "currency-btc": 0xf452,
  "currency-dollar": 0xf4c6,
  "currency-eth": 0xf4b6,
  "cursor-logo": 0xf39e,
  "cursor-text": 0xf304,
  "cutlery": 0xf455,
  "cylinder": 0xf456,
  "dashboard": 0xf457,
  "database": 0xf39f,
  "database-network": 0xf458,
  "debug-pause": 0xead1,
  "debug-restart": 0xead2,
  "debug-start": 0xeb2c,
  "debug-stop": 0xf3fe,
  "deckchair-umbrella": 0xf459,
  "desktop-download": 0xeac2,
  "device-camera": 0xf37c,
  "device-camera-video": 0xf405,
  "device-desktop": 0xf3a8,
  "device-mobile": 0xf3da,
  "diagram": 0xf41e,
  "diff": 0xf3a7,
  "diff-added": 0xf3a0,
  "diff-ignored": 0xf3a1,
  "diff-modified": 0xf3a2,
  "diff-multiple": 0xf3a3,
  "diff-removed": 0xf3a4,
  "diff-renamed": 0xf3a5,
  "diff-single": 0xf3a6,
  "diff-single-arrow-right-up": 0xec0b,
  "diff-single-dot": 0xec0c,
  "discard": 0xf409,
  "display": 0xf3a8,
  "display-check": 0xeb79,
  "display-circle": 0xeb7a,
  "display-connect": 0xeba9,
  "display-play": 0xeb7b,
  "display-waves": 0xf586,
  "displays": 0xf588,
  "dots-3-horizontal": 0xea7c,
  "dots-3-vertical": 0xeb10,
  "drop": 0xf4f5,
  "easel": 0xf45a,
  "edit": 0xea73,
  "elephant": 0xf4d6,
  "ellipsis": 0xea7c,
  "envelope": 0xf3a9,
  "envelope-open": 0xeb1b,
  "eraser": 0xeda0,
  "error": 0xf408,
  "exclamation-circle": 0xf3aa,
  "exclamation-triangle": 0xea6c,
  "execution-parallel": 0xf410,
  "execution-sequential": 0xf411,
  "extensions": 0xf3ab,
  "eye": 0xf3ac,
  "eye-closed": 0xf338,
  "eye-slash": 0xeae7,
  "fast-backward": 0xf416,
  "fast-forward": 0xf417,
  "feedback": 0xf37f,
  "file": 0xf3ad,
  "file-add": 0xed8d,
  "file-arrow-right-up": 0xeaee,
  "file-binary": 0xf3ad,
  "file-chevrons-left-right": 0xeae9,
  "file-code": 0xf3ad,
  "file-directory": 0xf3b2,
  "file-directory-create": 0xea80,
  "file-image": 0xeaea,
  "file-list": 0xec53,
  "file-lock": 0xeafa,
  "file-media": 0xeaea,
  "file-pdf": 0xeaeb,
  "file-plus": 0xed8d,
  "file-text": 0xf4bd,
  "file-type-adobe-illustrator": 0xf4ed,
  "file-type-adobe-photoshop": 0xf4eb,
  "file-type-babel": 0xf53b,
  "file-type-bazel": 0xf522,
  "file-type-bevy": 0xf527,
  "file-type-bicep": 0xf4fd,
  "file-type-biomejs": 0xf593,
  "file-type-bower": 0xf567,
  "file-type-bun": 0xf595,
  "file-type-c-plus-plus": 0xf50f,
  "file-type-c-sharp": 0xf510,
  "file-type-clojure": 0xf4d4,
  "file-type-crystal": 0xf4d8,
  "file-type-cuda": 0xf541,
  "file-type-dart": 0xf597,
  "file-type-docker": 0xf4a6,
  "file-type-ejs": 0xf54d,
  "file-type-elixir": 0xf4ef,
  "file-type-eslint": 0xf535,
  "file-type-f-sharp": 0xf4da,
  "file-type-firebase": 0xf4fb,
  "file-type-geckodriver": 0xf516,
  "file-type-git-meta": 0xf4a7,
  "file-type-go": 0xf55b,
  "file-type-godot": 0xf51e,
  "file-type-grails": 0xf502,
  "file-type-graphql": 0xf4a8,
  "file-type-groovy": 0xf537,
  "file-type-grunt": 0xf569,
  "file-type-gulp": 0xf547,
  "file-type-haml": 0xf55f,
  "file-type-handlebars": 0xf554,
  "file-type-haskell": 0xf4e9,
  "file-type-ionic": 0xf4a9,
  "file-type-java": 0xf4f9,
  "file-type-javascript": 0xf557,
  "file-type-julia": 0xf4aa,
  "file-type-jupyter": 0xf512,
  "file-type-karma": 0xf4c2,
  "file-type-kotlin": 0xf4ab,
  "file-type-latex": 0xf50a,
  "file-type-liquid": 0xf53d,
  "file-type-maven": 0xf551,
  "file-type-mustache": 0xf50c,
  "file-type-npm": 0xf518,
  "file-type-nunjucks": 0xf533,
  "file-type-ocaml": 0xf56b,
  "file-type-odata": 0xf506,
  "file-type-pdf": 0xf55c,
  "file-type-perl": 0xf56d,
  "file-type-platformio": 0xf52b,
  "file-type-powershell": 0xf4f1,
  "file-type-prettier": 0xf599,
  "file-type-prisma": 0xf52f,
  "file-type-prolog": 0xf545,
  "file-type-puppet": 0xf4e7,
  "file-type-python": 0xf4ac,
  "file-type-reason": 0xf549,
  "file-type-rescript": 0xf52d,
  "file-type-rollup": 0xf4ad,
  "file-type-rust": 0xf4ae,
  "file-type-sass": 0xf4ff,
  "file-type-sbt": 0xf54b,
  "file-type-scala": 0xf4c9,
  "file-type-slim": 0xf54f,
  "file-type-stylus": 0xf529,
  "file-type-sublime": 0xf508,
  "file-type-svelte": 0xf559,
  "file-type-swift": 0xf4af,
  "file-type-terraform": 0xf4b0,
  "file-type-typescript": 0xf558,
  "file-type-vala": 0xf51c,
  "file-type-vite": 0xf4b1,
  "file-type-vsc": 0xf51a,
  "file-type-vue": 0xf4b2,
  "file-type-web-assembly": 0xf4cb,
  "file-type-webpack": 0xf4b3,
  "file-type-windows": 0xf4b4,
  "file-type-yarn": 0xf520,
  "file-type-zig": 0xf539,
  "file-zip": 0xf3ad,
  "files": 0xf3ae,
  "film-reel": 0xf45c,
  "film-strip": 0xf4b7,
  "filter": 0xeaf1,
  "flag": 0xf3af,
  "flag-hill": 0xeb20,
  "flame": 0xeaf2,
  "flask": 0xea79,
  "flask-slash-circle": 0xebe1,
  "floppy-disc": 0xf3b0,
  "focus-window": 0xf3b1,
  "fold-dashed": 0xede9,
  "folder": 0xf3b2,
  "folder-active": 0xeaf6,
  "folder-arrow-right-up": 0xeaed,
  "folder-check": 0xeaf6,
  "folder-dashed": 0xf58d,
  "folder-library": 0xebdf,
  "folder-open": 0xeaf7,
  "folder-opened": 0xf3b2,
  "folder-plus": 0xea80,
  "folders": 0xeaec,
  "fork": 0xf41f,
  "funnel": 0xeaf1,
  "funnel-simple": 0xeb83,
  "game-controller": 0xf45e,
  "game-controller-retro": 0xf45f,
  "gauge": 0xeacd,
  "gear": 0xf393,
  "gem": 0xf3b3,
  "gift": 0xeaf9,
  "git-branch": 0xf3b4,
  "git-commit": 0xf3b6,
  "git-commit-horizontal": 0xf3b5,
  "git-compare": 0xf3b7,
  "git-fetch": 0xec1d,
  "git-fork": 0xf3b8,
  "git-merge": 0xf3b9,
  "git-pull": 0xf3bf,
  "git-pull-request": 0xf3be,
  "git-pull-request-closed": 0xf3ba,
  "git-pull-request-create": 0xf3bb,
  "git-pull-request-done": 0xf3bc,
  "git-pull-request-draft": 0xf3bd,
  "git-push": 0xf3c0,
  "github": 0xea84,
  "github-actions": 0xeaff,
  "globe": 0xf3c1,
  "graduation-cap": 0xeb21,
  "graph": 0xeb03,
  "graph-line": 0xebe2,
  "graph-scatter": 0xebe3,
  "grid": 0xf460,
  "grid-plus": 0xf461,
  "grid-sparkle": 0xf462,
  "gripper": 0xeb04,
  "hamburger": 0xf463,
  "hammer": 0xedab,
  "hash": 0xf4c5,
  "hat": 0xf464,
  "headphones": 0xf465,
  "headset": 0xf466,
  "heart": 0xf3c2,
  "hexagon": 0xf4dc,
  "history": 0xea82,
  "home": 0xeb06,
  "hourglass": 0xedcf,
  "house": 0xeb06,
  "i-circle": 0xf3c3,
  "image": 0xf3c5,
  "image-square": 0xf3c4,
  "inbox": 0xeb09,
  "infinity": 0xed8e,
  "info": 0xf3c3,
  "inspect": 0xebd1,
  "issue": 0xf3c6,
  "issue-closed": 0xf383,
  "issue-draft": 0xebd9,
  "issues": 0xf3aa,
  "joystick": 0xf467,
  "json": 0xf555,
  "kebab-horizontal": 0xea7c,
  "kebab-vertical": 0xeb10,
  "key": 0xeb11,
  "keyboard": 0xedac,
  "keyboard-tab": 0xf3c7,
  "laptop": 0xf3c9,
  "layers": 0xf3fc,
  "layout-dialog": 0xf58f,
  "layout-empty": 0xf590,
  "layout-floating-window": 0xf591,
  "layout-panel-bottom": 0xf3ca,
  "layout-panel-bottom-dock": 0xec49,
  "layout-panel-bottom-on": 0xebf2,
  "layout-panel-bottom-undock": 0xf2dd,
  "layout-panel-off": 0xf3ca,
  "layout-sidebar-left": 0xf3cb,
  "layout-sidebar-left-dock": 0xec4a,
  "layout-sidebar-left-off": 0xf3cb,
  "layout-sidebar-left-on": 0xebf3,
  "layout-sidebar-left-undock": 0xf23a,
  "layout-sidebar-right": 0xf3cc,
  "layout-sidebar-right-dock": 0xec4b,
  "layout-sidebar-right-off": 0xf3cc,
  "layout-sidebar-right-on": 0xebf4,
  "layout-sidebar-right-undock": 0xf23b,
  "layout-split-horizontal": 0xf3cd,
  "layout-split-horizontal-dashed": 0xec5b,
  "layout-split-horizontal-right-dock": 0xf305,
  "layout-split-horizontal-right-undock": 0xf306,
  "layout-split-vertical": 0xf3ce,
  "leaf": 0xf468,
  "lego": 0xf469,
  "library": 0xeb9c,
  "lightbulb": 0xf50d,
  "lightbulb-sparkle": 0xf3f4,
  "lightning": 0xf3cf,
  "link": 0xeb15,
  "link-external": 0xf3b1,
  "list-bullets": 0xeda5,
  "list-checks": 0xeab3,
  "list-filter": 0xeb83,
  "list-ordered": 0xeb16,
  "list-todo": 0xf3d0,
  "list-todo-subtask": 0xf425,
  "list-x": 0xeabf,
  "loading": 0xedca,
  "location": 0xf3d6,
  "lock": 0xf3d1,
  "lock-locked": 0xf3d1,
  "lock-unlocked": 0xf3d2,
  "logo-azure": 0xebd8,
  "logo-azure-devops": 0xebe8,
  "logo-figma": 0xf42a,
  "logo-github": 0xea84,
  "logo-gitlab": 0xf42b,
  "logo-jira": 0xf4e3,
  "logo-linear": 0xf42c,
  "logo-markdown": 0xf319,
  "logo-mcp": 0xec47,
  "logo-microsoft-teams": 0xf4e4,
  "logo-notion": 0xf42d,
  "logo-python": 0xec39,
  "logo-sentry": 0xf4e5,
  "logo-slack": 0xf42e,
  "logo-vscode": 0xec29,
  "logo-vscode-insiders": 0xec2a,
  "logo-x": 0xeb72,
  "mac-mini": 0xf46a,
  "magic-wand": 0xebcf,
  "magnet": 0xebae,
  "magnifying-glass": 0xf3d5,
  "magnifying-glass-fuzzy": 0xec0d,
  "magnifying-glass-minus": 0xf3d3,
  "magnifying-glass-plus": 0xf3d4,
  "magnifying-glass-slash-circle": 0xeb4e,
  "magnifying-glass-sparkle": 0xec50,
  "magnifyingGlass": 0xf3d5,
  "magnifyingGlass-minus": 0xf3d3,
  "magnifyingGlass-plus": 0xf3d4,
  "magnifyingGlass-slash-circle": 0xeb4e,
  "mail": 0xf3a9,
  "map": 0xec05,
  "map-pin": 0xf3d6,
  "mark-github": 0xea84,
  "markdown": 0xf55d,
  "mask-happy": 0xf46b,
  "masks-happy": 0xf46c,
  "mcp": 0xec47,
  "megaphone": 0xeb1e,
  "mention": 0xf375,
  "menu": 0xeb94,
  "merge": 0xebab,
  "mic": 0xf3d7,
  "microscope": 0xea79,
  "minus": 0xf3d9,
  "minus-circle": 0xf3d8,
  "minus-small": 0xf46d,
  "mobile": 0xf3da,
  "moon": 0xf3db,
  "moon-sparkle": 0xf46e,
  "moon-z": 0xf46f,
  "more": 0xea7c,
  "music": 0xf3dc,
  "mute": 0xf3f6,
  "new-file": 0xed8d,
  "new-folder": 0xea80,
  "newspaper": 0xf470,
  "note": 0xeb26,
  "one-circle": 0xf420,
  "organization": 0xea7e,
  "organization-filled": 0xea7e,
  "owl": 0xf543,
  "package": 0xf4e2,
  "package-zipper": 0xf552,
  "paint-roller": 0xf471,
  "palette": 0xf4b8,
  "paperclip": 0xec54,
  "paperplane": 0xf3dd,
  "paragraph": 0xf4c3,
  "pass": 0xf383,
  "pause": 0xead1,
  "pause-circle": 0xf3de,
  "paw": 0xf473,
  "pen-nib": 0xf2e3,
  "pencil": 0xea73,
  "pencil-square": 0xeddd,
  "pentagon": 0xf4de,
  "people": 0xea7e,
  "people-3": 0xf474,
  "percent": 0xec33,
  "person": 0xf3df,
  "person-add": 0xebcd,
  "person-chat-bubble": 0xeb96,
  "person-circle": 0xeb99,
  "person-follow": 0xebcd,
  "person-plus": 0xebcd,
  "piano": 0xec1a,
  "pie-chart": 0xf37d,
  "pilcrow": 0xeb7d,
  "pin": 0xf3e0,
  "pin-slash": 0xf40b,
  "pipe": 0xf531,
  "plan": 0xf3e1,
  "plane": 0xf475,
  "play": 0xeb2c,
  "play-bug": 0xeb91,
  "play-circle": 0xf3e2,
  "play-slow": 0xf421,
  "play-super-fast": 0xf422,
  "playback-loop": 0xf40d,
  "plays-bug": 0xebdc,
  "plug": 0xf3e3,
  "plug-slash": 0xead0,
  "plus": 0xf3e5,
  "plus-circle": 0xf3e4,
  "plus-minus": 0xf302,
  "pointer-arrow": 0xf3e6,
  "pug": 0xf565,
  "pulse": 0xeb31,
  "puzzle-piece": 0xf476,
  "question": 0xf2e5,
  "question-circle": 0xf3e7,
  "quote": 0xeb33,
  "radar": 0xf477,
  "radio-tower": 0xeb34,
  "rect-magnifying-glass": 0xf351,
  "rect-magnifyingGlass": 0xf351,
  "redo": 0xeb37,
  "refresh": 0xeb37,
  "regex": 0xeb38,
  "remote-control": 0xf58a,
  "remove": 0xf3d9,
  "remove-close": 0xf409,
  "replace": 0xf351,
  "replace-all": 0xf351,
  "report": 0xeb42,
  "return": 0xebea,
  "review": 0xf2e7,
  "robot": 0xf3e8,
  "rocket": 0xeb44,
  "rocking-chair": 0xf478,
  "rss": 0xeb47,
  "ruler": 0xea96,
  "rules": 0xf414,
  "run": 0xeb2c,
  "satellite": 0xf479,
  "scales": 0xeb12,
  "seal": 0xf3ea,
  "seal-check": 0xf3e9,
  "seal-question": 0xeb76,
  "search": 0xf3d5,
  "search-stop": 0xeb4e,
  "send": 0xf3dd,
  "server": 0xf48f,
  "servers": 0xeb50,
  "settings": 0xf3f0,
  "settings-gear": 0xf393,
  "shapes-square-circle": 0xf4b9,
  "share": 0xec25,
  "shield": 0xf3ee,
  "shield-check": 0xf3eb,
  "shield-question": 0xf3ec,
  "shield-x": 0xf3ed,
  "shoe-fast": 0xf47b,
  "shopping-bag": 0xf47c,
  "shopping-basket": 0xf47d,
  "signal": 0xf47e,
  "skills": 0xf3f4,
  "skills-capability": 0xf3f4,
  "slash-circle": 0xf3ef,
  "sliders": 0xf3f0,
  "smartwatch": 0xf2e9,
  "smiley-happy": 0xf3f1,
  "smiley-happy-square": 0xf47f,
  "smiley-neutral": 0xf3f2,
  "smiley-plus": 0xeb35,
  "smiley-sad": 0xf3f3,
  "snowflake": 0xf480,
  "soccer-ball": 0xf481,
  "sort-ascending": 0xf2ea,
  "sort-descending": 0xf2eb,
  "source-control": 0xf3b4,
  "sparkle": 0xf3f4,
  "sparkles": 0xf3f4,
  "speaker-hifi": 0xf482,
  "speaker-waves": 0xf3f5,
  "speaker-x": 0xf3f6,
  "spinner": 0xedca,
  "split": 0xf42f,
  "split-horizontal": 0xf3cd,
  "split-vertical": 0xf3ce,
  "sprint": 0xf426,
  "square": 0xf3f7,
  "square-dashed": 0xf58e,
  "square-dot": 0xf423,
  "squares": 0xf3fb,
  "squares-minus": 0xf3f8,
  "squares-plus": 0xf3f9,
  "squares-x": 0xf3fa,
  "stack": 0xf3fc,
  "star": 0xf3fd,
  "star-empty": 0xf3fd,
  "star-full": 0xeb59,
  "status-done": 0xf383,
  "status-draft": 0xedbb,
  "status-needs-attention": 0xf3aa,
  "stop": 0xed86,
  "stop-circle": 0xf3fe,
  "stopwatch": 0xf418,
  "storefront": 0xf483,
  "sun": 0xf3ff,
  "swatches": 0xf484,
  "symbol-folder": 0xf3b2,
  "sync": 0xea77,
  "t-shirt": 0xf485,
  "table": 0xf4bb,
  "tabs": 0xf2be,
  "tag": 0xf400,
  "tags-chevron-down": 0xf57f,
  "tags-chevron-left": 0xf581,
  "tags-chevron-right": 0xf583,
  "tags-chevron-up": 0xf585,
  "target": 0xebf8,
  "terminal": 0xf50e,
  "terminal-rectangle": 0xf401,
  "text-aa": 0xf55a,
  "text-ab": 0xeb2e,
  "text-b": 0xeaa3,
  "text-c": 0xf4cf,
  "text-d": 0xf4cd,
  "text-italic": 0xeb0d,
  "text-j": 0xf4f8,
  "text-r": 0xf4d2,
  "text-s": 0xf524,
  "text-strikethrough": 0xf525,
  "text-t": 0xf4d0,
  "text-t-square": 0xf402,
  "text-tt": 0xeb69,
  "text-y": 0xf4e0,
  "thinking-high": 0xf427,
  "thinking-low": 0xf428,
  "thinking-medium": 0xf429,
  "threads-parallel": 0xf40e,
  "threads-single": 0xf40f,
  "three-bars": 0xeb6a,
  "thumbs-down": 0xf560,
  "thumbs-up": 0xf561,
  "thumbsdown": 0xf560,
  "thumbsup": 0xf561,
  "traffic-cone": 0xf34d,
  "trafficCone": 0xf34d,
  "trash": 0xf403,
  "trashcan": 0xf403,
  "tray": 0xeb09,
  "treasure-chest": 0xf486,
  "trending-down": 0xf487,
  "trending-up": 0xf488,
  "triangle-small-down": 0xeb6e,
  "triangle-small-left": 0xeb6f,
  "triangle-small-right": 0xeb70,
  "triangle-small-up": 0xeb71,
  "twig": 0xf504,
  "unfold-dashed": 0xede8,
  "unlock": 0xf3d2,
  "unmute": 0xf3f5,
  "unverified": 0xeb76,
  "vault": 0xf489,
  "verified": 0xf3e9,
  "versions": 0xf404,
  "video-camera": 0xf405,
  "vm": 0xf3a8,
  "vr": 0xf48a,
  "vr-headset": 0xf562,
  "vr-headset-head": 0xf563,
  "wallet": 0xf48b,
  "wand": 0xf3f4,
  "warning": 0xea6c,
  "watch": 0xeb7c,
  "waveform": 0xf4c4,
  "whole-word": 0xeb7e,
  "window": 0xf406,
  "window-pointer-arrow": 0xebd1,
  "windows": 0xf407,
  "wrench": 0xeb6d,
  "x": 0xf409,
  "x-circle": 0xf408,
  "yarn": 0xf514,
  "zap": 0xf3f4,
  "zipper": 0xf552,
  "zoom-in": 0xf3d4,
  "zoom-out": 0xf3d3,
  "zzz": 0xf48e,
} as const;

export const SAND_ICON_FILLED_CODE_POINTS_WINDOWS = {
  "account": 0xeb99,
  "add": 0xf3e5,
  "agent": 0xf413,
  "agent-circle": 0xf430,
  "agent-square": 0xf431,
  "agents": 0xf432,
  "agents-swarm": 0xf412,
  "alarm-clock": 0xf58c,
  "alert": 0xea6c,
  "archive": 0xea98,
  "army-base": 0xf433,
  "arrow-block-down": 0xf35d,
  "arrow-block-left": 0xf35e,
  "arrow-block-line-down": 0xf56f,
  "arrow-block-line-left": 0xf571,
  "arrow-block-line-right": 0xf573,
  "arrow-block-line-up": 0xf575,
  "arrow-block-right": 0xf35f,
  "arrow-block-up": 0xf360,
  "arrow-bracket-from-down": 0xf34e,
  "arrow-bracket-from-left": 0xf34f,
  "arrow-bracket-from-right": 0xf359,
  "arrow-bracket-from-up": 0xec28,
  "arrow-bracket-from-up-dashed": 0xec27,
  "arrow-bracket-to-down": 0xf4e1,
  "arrow-bracket-to-left": 0xf358,
  "arrow-bracket-to-right": 0xf357,
  "arrow-bracket-to-up": 0xf356,
  "arrow-ccw": 0xead2,
  "arrow-circle-down": 0xf361,
  "arrow-circle-left": 0xf362,
  "arrow-circle-right": 0xf363,
  "arrow-circle-up": 0xf364,
  "arrow-cw": 0xeb37,
  "arrow-down": 0xf365,
  "arrow-left": 0xf368,
  "arrow-left-down": 0xf366,
  "arrow-left-up": 0xf367,
  "arrow-right": 0xf36b,
  "arrow-right-down": 0xf369,
  "arrow-right-up": 0xf36a,
  "arrow-square-down": 0xf36c,
  "arrow-square-from-down": 0xf355,
  "arrow-square-from-left": 0xf354,
  "arrow-square-from-right": 0xea6e,
  "arrow-square-from-up": 0xebac,
  "arrow-square-left": 0xf36f,
  "arrow-square-left-down": 0xf36d,
  "arrow-square-left-top": 0xf36e,
  "arrow-square-left-up": 0xf36e,
  "arrow-square-right": 0xf372,
  "arrow-square-right-down": 0xf370,
  "arrow-square-right-top": 0xf371,
  "arrow-square-right-up": 0xf371,
  "arrow-square-to-down": 0xedae,
  "arrow-square-to-left": 0xf353,
  "arrow-square-to-right": 0xea6f,
  "arrow-square-to-up": 0xf352,
  "arrow-square-up": 0xf373,
  "arrow-swap": 0xebcb,
  "arrow-u-up-left": 0xed84,
  "arrow-u-up-right": 0xf31e,
  "arrow-up": 0xf374,
  "arrows-both-horizontal": 0xea99,
  "arrows-both-vertical": 0xf2ca,
  "arrows-ccw": 0xf30f,
  "arrows-ccw-angular": 0xf2cc,
  "arrows-contract": 0xf310,
  "arrows-contract-simple": 0xf2cd,
  "arrows-cw": 0xea77,
  "arrows-down-up": 0xf2ce,
  "arrows-expand": 0xf311,
  "arrows-expand-simple": 0xf2cf,
  "arrows-left-right": 0xebcb,
  "arrows-out-cardinal": 0xeb22,
  "asterisk": 0xedbf,
  "at": 0xf375,
  "atom": 0xf4bc,
  "bandaid": 0xf435,
  "banknote": 0xf500,
  "banknotes-stack": 0xf436,
  "barbell": 0xf437,
  "basketball": 0xf438,
  "beach-umbrella": 0xf439,
  "beaker": 0xea79,
  "beaker-stop": 0xebe1,
  "beehouse": 0xf43a,
  "bell": 0xeaa2,
  "bell-dot": 0xeb9a,
  "bell-slash": 0xec08,
  "binary": 0xf556,
  "binoculars": 0xeb68,
  "bluetooth": 0xf43b,
  "board-kanban": 0xf376,
  "book": 0xf414,
  "book-open": 0xf377,
  "bookmark": 0xf378,
  "books": 0xeb9c,
  "bowtie": 0xf4f3,
  "bracket": 0xf555,
  "bracket-dot": 0xebe5,
  "bracket-error": 0xebe6,
  "brackets-curly": 0xf555,
  "brackets-curly-dot": 0xebe5,
  "brackets-curly-x": 0xebe6,
  "brackets-square": 0xea8a,
  "brain": 0xed87,
  "brain-hourglass": 0xf43c,
  "brain-simple": 0xf43d,
  "brain-simplest": 0xf43e,
  "brain-slash": 0xf43f,
  "briefcase": 0xeaac,
  "browser": 0xf379,
  "browsers": 0xf37a,
  "brush": 0xedb3,
  "bug": 0xf37b,
  "bugbot": 0xec59,
  "building": 0xf440,
  "buildings": 0xf441,
  "bullseye": 0xebf8,
  "calculator": 0xf442,
  "calendar": 0xeab0,
  "calendar-hourglass": 0xf415,
  "camera": 0xf37c,
  "car": 0xf443,
  "cardholder": 0xf444,
  "castle": 0xf445,
  "cd": 0xf4b5,
  "chart-bars": 0xeb03,
  "chart-line": 0xebe2,
  "chart-pie": 0xf37d,
  "chart-pyramid": 0xf419,
  "chart-scatter": 0xebe3,
  "chat-bubble": 0xf381,
  "chat-bubble-chevrons-left-right": 0xf37e,
  "chat-bubble-ellipsis": 0xf37f,
  "chat-bubble-exclamation": 0xeb42,
  "chat-bubble-pencil": 0xedc3,
  "chat-bubble-question": 0xf380,
  "chat-bubbles": 0xf382,
  "chat-bubbles-grid": 0xf424,
  "chatBubble": 0xf381,
  "chatBubble-ellipsis": 0xf37f,
  "chatBubble-exclamation": 0xeb42,
  "chatBubble-question": 0xf380,
  "chatBubbles": 0xf382,
  "check": 0xf385,
  "check-circle": 0xf383,
  "check-square": 0xf384,
  "checks": 0xebb1,
  "chef-hat": 0xf447,
  "chess-king": 0xf448,
  "chess-tower": 0xf449,
  "chevron-circle-down": 0xf577,
  "chevron-circle-left": 0xf579,
  "chevron-circle-right": 0xf57b,
  "chevron-circle-up": 0xf57d,
  "chevron-down": 0xf387,
  "chevron-down-small": 0xf386,
  "chevron-left": 0xf389,
  "chevron-left-small": 0xf388,
  "chevron-right": 0xf38b,
  "chevron-right-small": 0xf38a,
  "chevron-up": 0xf38d,
  "chevron-up-small": 0xf38c,
  "chevrons-down": 0xeaf3,
  "chevrons-down-up": 0xeaf5,
  "chevrons-left": 0xedd4,
  "chevrons-left-right": 0xf2d7,
  "chevrons-right": 0xf31d,
  "chevrons-right-dotted-left": 0xedc6,
  "chevrons-up": 0xeaf4,
  "chevrons-up-down": 0xedcb,
  "chip": 0xec19,
  "chip-simple": 0xf41a,
  "circle": 0xf38f,
  "circle-circle": 0xf38e,
  "circle-dashed": 0xedbb,
  "circles": 0xf390,
  "circles-check": 0xec2e,
  "clipboard": 0xedc9,
  "clock": 0xf391,
  "clone": 0xf399,
  "close": 0xf409,
  "cloud": 0xf392,
  "cloud-arrow-down": 0xeac2,
  "cloud-arrow-up": 0xeac3,
  "cloud-download": 0xeac2,
  "cloud-upload": 0xeac3,
  "code": 0xf44a,
  "code-brackets": 0xea8a,
  "code-simple": 0xf4c1,
  "cog": 0xf393,
  "collection": 0xf395,
  "collection-plus": 0xf394,
  "color-mode": 0xf396,
  "command": 0xf397,
  "comment": 0xea6b,
  "comment-dashed": 0xec0e,
  "comment-discussion": 0xf382,
  "comment-dot": 0xec0a,
  "comments": 0xeac7,
  "compass": 0xf398,
  "compass-check": 0xebd7,
  "compass-dot": 0xebd6,
  "conversation": 0xf382,
  "cookie": 0xf4f6,
  "copilot": 0xf3f4,
  "copy": 0xf399,
  "corners-in": 0xeb4d,
  "corners-out": 0xeb4c,
  "corners-out-check": 0xf2da,
  "corners-out-sparkle": 0xf44d,
  "cost-high": 0xf41b,
  "cost-low": 0xf41c,
  "cost-medium": 0xf41d,
  "credit-card": 0xf39a,
  "cross-medical": 0xf44e,
  "crosshair": 0xf44f,
  "crown": 0xf53f,
  "crystal-ball": 0xf450,
  "cube": 0xf39d,
  "cube-coordinates": 0xf451,
  "cube-nodes": 0xf39b,
  "cube-transparent": 0xf39c,
  "currency-btc": 0xf452,
  "currency-dollar": 0xf4c6,
  "currency-eth": 0xf4b6,
  "cursor-logo": 0xf39e,
  "cursor-text": 0xf304,
  "cutlery": 0xf455,
  "cylinder": 0xf456,
  "dashboard": 0xf457,
  "database": 0xf39f,
  "database-network": 0xf458,
  "debug-pause": 0xead1,
  "debug-restart": 0xead2,
  "debug-start": 0xeb2c,
  "debug-stop": 0xf3fe,
  "deckchair-umbrella": 0xf459,
  "desktop-download": 0xeac2,
  "device-camera": 0xf37c,
  "device-camera-video": 0xf405,
  "device-desktop": 0xf3a8,
  "device-mobile": 0xf3da,
  "diagram": 0xf41e,
  "diff": 0xf3a7,
  "diff-added": 0xf3a0,
  "diff-ignored": 0xf3a1,
  "diff-modified": 0xf3a2,
  "diff-multiple": 0xf3a3,
  "diff-removed": 0xf3a4,
  "diff-renamed": 0xf3a5,
  "diff-single": 0xf3a6,
  "diff-single-arrow-right-up": 0xec0b,
  "diff-single-dot": 0xec0c,
  "discard": 0xf409,
  "display": 0xf3a8,
  "display-check": 0xeb79,
  "display-circle": 0xeb7a,
  "display-connect": 0xeba9,
  "display-play": 0xeb7b,
  "display-waves": 0xf586,
  "displays": 0xf588,
  "dots-3-horizontal": 0xea7c,
  "dots-3-vertical": 0xeb10,
  "drop": 0xf4f5,
  "easel": 0xf45a,
  "edit": 0xea73,
  "elephant": 0xf4d6,
  "ellipsis": 0xea7c,
  "envelope": 0xf3a9,
  "envelope-open": 0xeb1b,
  "eraser": 0xeda0,
  "error": 0xf408,
  "exclamation-circle": 0xf3aa,
  "exclamation-triangle": 0xea6c,
  "execution-parallel": 0xf410,
  "execution-sequential": 0xf411,
  "extensions": 0xf3ab,
  "eye": 0xf3ac,
  "eye-closed": 0xf338,
  "eye-slash": 0xeae7,
  "fast-backward": 0xf416,
  "fast-forward": 0xf417,
  "feedback": 0xf37f,
  "file": 0xf3ad,
  "file-add": 0xed8d,
  "file-arrow-right-up": 0xeaee,
  "file-binary": 0xf3ad,
  "file-chevrons-left-right": 0xeae9,
  "file-code": 0xf3ad,
  "file-directory": 0xf3b2,
  "file-directory-create": 0xea80,
  "file-image": 0xeaea,
  "file-list": 0xec53,
  "file-lock": 0xeafa,
  "file-media": 0xeaea,
  "file-pdf": 0xeaeb,
  "file-plus": 0xed8d,
  "file-text": 0xf4bd,
  "file-type-adobe-illustrator": 0xf4ed,
  "file-type-adobe-photoshop": 0xf4eb,
  "file-type-babel": 0xf53b,
  "file-type-bazel": 0xf522,
  "file-type-bevy": 0xf527,
  "file-type-bicep": 0xf4fd,
  "file-type-biomejs": 0xf593,
  "file-type-bower": 0xf567,
  "file-type-bun": 0xf595,
  "file-type-c-plus-plus": 0xf50f,
  "file-type-c-sharp": 0xf510,
  "file-type-clojure": 0xf4d4,
  "file-type-crystal": 0xf4d8,
  "file-type-cuda": 0xf541,
  "file-type-dart": 0xf597,
  "file-type-docker": 0xf4a6,
  "file-type-ejs": 0xf54d,
  "file-type-elixir": 0xf4ef,
  "file-type-eslint": 0xf535,
  "file-type-f-sharp": 0xf4da,
  "file-type-firebase": 0xf4fb,
  "file-type-geckodriver": 0xf516,
  "file-type-git-meta": 0xf4a7,
  "file-type-go": 0xf55b,
  "file-type-godot": 0xf51e,
  "file-type-grails": 0xf502,
  "file-type-graphql": 0xf4a8,
  "file-type-groovy": 0xf537,
  "file-type-grunt": 0xf569,
  "file-type-gulp": 0xf547,
  "file-type-haml": 0xf55f,
  "file-type-handlebars": 0xf554,
  "file-type-haskell": 0xf4e9,
  "file-type-ionic": 0xf4a9,
  "file-type-java": 0xf4f9,
  "file-type-javascript": 0xf557,
  "file-type-julia": 0xf4aa,
  "file-type-jupyter": 0xf512,
  "file-type-karma": 0xf4c2,
  "file-type-kotlin": 0xf4ab,
  "file-type-latex": 0xf50a,
  "file-type-liquid": 0xf53d,
  "file-type-maven": 0xf551,
  "file-type-mustache": 0xf50c,
  "file-type-npm": 0xf518,
  "file-type-nunjucks": 0xf533,
  "file-type-ocaml": 0xf56b,
  "file-type-odata": 0xf506,
  "file-type-pdf": 0xf55c,
  "file-type-perl": 0xf56d,
  "file-type-platformio": 0xf52b,
  "file-type-powershell": 0xf4f1,
  "file-type-prettier": 0xf599,
  "file-type-prisma": 0xf52f,
  "file-type-prolog": 0xf545,
  "file-type-puppet": 0xf4e7,
  "file-type-python": 0xf4ac,
  "file-type-reason": 0xf549,
  "file-type-rescript": 0xf52d,
  "file-type-rollup": 0xf4ad,
  "file-type-rust": 0xf4ae,
  "file-type-sass": 0xf4ff,
  "file-type-sbt": 0xf54b,
  "file-type-scala": 0xf4c9,
  "file-type-slim": 0xf54f,
  "file-type-stylus": 0xf529,
  "file-type-sublime": 0xf508,
  "file-type-svelte": 0xf559,
  "file-type-swift": 0xf4af,
  "file-type-terraform": 0xf4b0,
  "file-type-typescript": 0xf558,
  "file-type-vala": 0xf51c,
  "file-type-vite": 0xf4b1,
  "file-type-vsc": 0xf51a,
  "file-type-vue": 0xf4b2,
  "file-type-web-assembly": 0xf4cb,
  "file-type-webpack": 0xf4b3,
  "file-type-windows": 0xf4b4,
  "file-type-yarn": 0xf520,
  "file-type-zig": 0xf539,
  "file-zip": 0xf3ad,
  "files": 0xf3ae,
  "film-reel": 0xf45c,
  "film-strip": 0xf4b7,
  "filter": 0xeaf1,
  "flag": 0xf3af,
  "flag-hill": 0xeb20,
  "flame": 0xeaf2,
  "flask": 0xea79,
  "flask-slash-circle": 0xebe1,
  "floppy-disc": 0xf3b0,
  "focus-window": 0xf3b1,
  "fold-dashed": 0xede9,
  "folder": 0xf3b2,
  "folder-active": 0xeaf6,
  "folder-arrow-right-up": 0xeaed,
  "folder-check": 0xeaf6,
  "folder-dashed": 0xf58d,
  "folder-library": 0xebdf,
  "folder-open": 0xeaf7,
  "folder-opened": 0xf3b2,
  "folder-plus": 0xea80,
  "folders": 0xeaec,
  "fork": 0xf41f,
  "funnel": 0xeaf1,
  "funnel-simple": 0xeb83,
  "game-controller": 0xf45e,
  "game-controller-retro": 0xf45f,
  "gauge": 0xeacd,
  "gear": 0xf393,
  "gem": 0xf3b3,
  "gift": 0xeaf9,
  "git-branch": 0xf3b4,
  "git-commit": 0xf3b6,
  "git-commit-horizontal": 0xf3b5,
  "git-compare": 0xf3b7,
  "git-fetch": 0xec1d,
  "git-fork": 0xf3b8,
  "git-merge": 0xf3b9,
  "git-pull": 0xf3bf,
  "git-pull-request": 0xf3be,
  "git-pull-request-closed": 0xf3ba,
  "git-pull-request-create": 0xf3bb,
  "git-pull-request-done": 0xf3bc,
  "git-pull-request-draft": 0xf3bd,
  "git-push": 0xf3c0,
  "github": 0xea84,
  "github-actions": 0xeaff,
  "globe": 0xf3c1,
  "graduation-cap": 0xeb21,
  "graph": 0xeb03,
  "graph-line": 0xebe2,
  "graph-scatter": 0xebe3,
  "grid": 0xf460,
  "grid-plus": 0xf461,
  "grid-sparkle": 0xf462,
  "gripper": 0xeb04,
  "hamburger": 0xf463,
  "hammer": 0xedab,
  "hash": 0xf4c5,
  "hat": 0xf464,
  "headphones": 0xf465,
  "headset": 0xf466,
  "heart": 0xf3c2,
  "hexagon": 0xf4dc,
  "history": 0xea82,
  "home": 0xeb06,
  "hourglass": 0xedcf,
  "house": 0xeb06,
  "i-circle": 0xf3c3,
  "image": 0xf3c5,
  "image-square": 0xf3c4,
  "inbox": 0xeb09,
  "infinity": 0xed8e,
  "info": 0xf3c3,
  "inspect": 0xebd1,
  "issue": 0xf3c6,
  "issue-closed": 0xf383,
  "issue-draft": 0xebd9,
  "issues": 0xf3aa,
  "joystick": 0xf467,
  "json": 0xf555,
  "kebab-horizontal": 0xea7c,
  "kebab-vertical": 0xeb10,
  "key": 0xeb11,
  "keyboard": 0xedac,
  "keyboard-tab": 0xf3c7,
  "laptop": 0xf3c9,
  "layers": 0xf3fc,
  "layout-dialog": 0xf58f,
  "layout-empty": 0xf590,
  "layout-floating-window": 0xf591,
  "layout-panel-bottom": 0xf3ca,
  "layout-panel-bottom-dock": 0xec49,
  "layout-panel-bottom-on": 0xebf2,
  "layout-panel-bottom-undock": 0xf2dd,
  "layout-panel-off": 0xf3ca,
  "layout-sidebar-left": 0xf3cb,
  "layout-sidebar-left-dock": 0xec4a,
  "layout-sidebar-left-off": 0xf3cb,
  "layout-sidebar-left-on": 0xebf3,
  "layout-sidebar-left-undock": 0xf23a,
  "layout-sidebar-right": 0xf3cc,
  "layout-sidebar-right-dock": 0xec4b,
  "layout-sidebar-right-off": 0xf3cc,
  "layout-sidebar-right-on": 0xebf4,
  "layout-sidebar-right-undock": 0xf23b,
  "layout-split-horizontal": 0xf3cd,
  "layout-split-horizontal-dashed": 0xec5b,
  "layout-split-horizontal-right-dock": 0xf305,
  "layout-split-horizontal-right-undock": 0xf306,
  "layout-split-vertical": 0xf3ce,
  "leaf": 0xf468,
  "lego": 0xf469,
  "library": 0xeb9c,
  "lightbulb": 0xf50d,
  "lightbulb-sparkle": 0xf3f4,
  "lightning": 0xf3cf,
  "link": 0xeb15,
  "link-external": 0xf3b1,
  "list-bullets": 0xeda5,
  "list-checks": 0xeab3,
  "list-filter": 0xeb83,
  "list-ordered": 0xeb16,
  "list-todo": 0xf3d0,
  "list-todo-subtask": 0xf425,
  "list-x": 0xeabf,
  "loading": 0xedca,
  "location": 0xf3d6,
  "lock": 0xf3d1,
  "lock-locked": 0xf3d1,
  "lock-unlocked": 0xf3d2,
  "logo-azure": 0xebd8,
  "logo-azure-devops": 0xebe8,
  "logo-figma": 0xf42a,
  "logo-github": 0xea84,
  "logo-gitlab": 0xf42b,
  "logo-jira": 0xf4e3,
  "logo-linear": 0xf42c,
  "logo-markdown": 0xf319,
  "logo-mcp": 0xec47,
  "logo-microsoft-teams": 0xf4e4,
  "logo-notion": 0xf42d,
  "logo-python": 0xec39,
  "logo-sentry": 0xf4e5,
  "logo-slack": 0xf42e,
  "logo-vscode": 0xec29,
  "logo-vscode-insiders": 0xec2a,
  "logo-x": 0xeb72,
  "mac-mini": 0xf46a,
  "magic-wand": 0xebcf,
  "magnet": 0xebae,
  "magnifying-glass": 0xf3d5,
  "magnifying-glass-fuzzy": 0xec0d,
  "magnifying-glass-minus": 0xf3d3,
  "magnifying-glass-plus": 0xf3d4,
  "magnifying-glass-slash-circle": 0xeb4e,
  "magnifying-glass-sparkle": 0xec50,
  "magnifyingGlass": 0xf3d5,
  "magnifyingGlass-minus": 0xf3d3,
  "magnifyingGlass-plus": 0xf3d4,
  "magnifyingGlass-slash-circle": 0xeb4e,
  "mail": 0xf3a9,
  "map": 0xec05,
  "map-pin": 0xf3d6,
  "mark-github": 0xea84,
  "markdown": 0xf55d,
  "mask-happy": 0xf46b,
  "masks-happy": 0xf46c,
  "mcp": 0xec47,
  "megaphone": 0xeb1e,
  "mention": 0xf375,
  "menu": 0xeb94,
  "merge": 0xebab,
  "mic": 0xf3d7,
  "microscope": 0xea79,
  "minus": 0xf3d9,
  "minus-circle": 0xf3d8,
  "minus-small": 0xf46d,
  "mobile": 0xf3da,
  "moon": 0xf3db,
  "moon-sparkle": 0xf46e,
  "moon-z": 0xf46f,
  "more": 0xea7c,
  "music": 0xf3dc,
  "mute": 0xf3f6,
  "new-file": 0xed8d,
  "new-folder": 0xea80,
  "newspaper": 0xf470,
  "note": 0xeb26,
  "one-circle": 0xf420,
  "organization": 0xea7e,
  "organization-filled": 0xea7e,
  "owl": 0xf543,
  "package": 0xf4e2,
  "package-zipper": 0xf552,
  "paint-roller": 0xf471,
  "palette": 0xf4b8,
  "paperclip": 0xec54,
  "paperplane": 0xf3dd,
  "paragraph": 0xf4c3,
  "pass": 0xf383,
  "pause": 0xead1,
  "pause-circle": 0xf3de,
  "paw": 0xf473,
  "pen-nib": 0xf2e3,
  "pencil": 0xea73,
  "pencil-square": 0xeddd,
  "pentagon": 0xf4de,
  "people": 0xea7e,
  "people-3": 0xf474,
  "percent": 0xec33,
  "person": 0xf3df,
  "person-add": 0xebcd,
  "person-chat-bubble": 0xeb96,
  "person-circle": 0xeb99,
  "person-follow": 0xebcd,
  "person-plus": 0xebcd,
  "piano": 0xec1a,
  "pie-chart": 0xf37d,
  "pilcrow": 0xeb7d,
  "pin": 0xf3e0,
  "pin-slash": 0xf40b,
  "pipe": 0xf531,
  "plan": 0xf3e1,
  "plane": 0xf475,
  "play": 0xeb2c,
  "play-bug": 0xeb91,
  "play-circle": 0xf3e2,
  "play-slow": 0xf421,
  "play-super-fast": 0xf422,
  "playback-loop": 0xf40d,
  "plays-bug": 0xebdc,
  "plug": 0xf3e3,
  "plug-slash": 0xead0,
  "plus": 0xf3e5,
  "plus-circle": 0xf3e4,
  "plus-minus": 0xf302,
  "pointer-arrow": 0xf3e6,
  "pug": 0xf565,
  "pulse": 0xeb31,
  "puzzle-piece": 0xf476,
  "question": 0xf2e5,
  "question-circle": 0xf3e7,
  "quote": 0xeb33,
  "radar": 0xf477,
  "radio-tower": 0xeb34,
  "rect-magnifying-glass": 0xf351,
  "rect-magnifyingGlass": 0xf351,
  "redo": 0xeb37,
  "refresh": 0xeb37,
  "regex": 0xeb38,
  "remote-control": 0xf58a,
  "remove": 0xf3d9,
  "remove-close": 0xf409,
  "replace": 0xf351,
  "replace-all": 0xf351,
  "report": 0xeb42,
  "return": 0xebea,
  "review": 0xf2e7,
  "robot": 0xf3e8,
  "rocket": 0xeb44,
  "rocking-chair": 0xf478,
  "rss": 0xeb47,
  "ruler": 0xea96,
  "rules": 0xf414,
  "run": 0xeb2c,
  "satellite": 0xf479,
  "scales": 0xeb12,
  "seal": 0xf3ea,
  "seal-check": 0xf3e9,
  "seal-question": 0xeb76,
  "search": 0xf3d5,
  "search-stop": 0xeb4e,
  "send": 0xf3dd,
  "server": 0xf48f,
  "servers": 0xeb50,
  "settings": 0xf3f0,
  "settings-gear": 0xf393,
  "shapes-square-circle": 0xf4b9,
  "share": 0xec25,
  "shield": 0xf3ee,
  "shield-check": 0xf3eb,
  "shield-question": 0xf3ec,
  "shield-x": 0xf3ed,
  "shoe-fast": 0xf47b,
  "shopping-bag": 0xf47c,
  "shopping-basket": 0xf47d,
  "signal": 0xf47e,
  "skills": 0xf3f4,
  "skills-capability": 0xf3f4,
  "slash-circle": 0xf3ef,
  "sliders": 0xf3f0,
  "smartwatch": 0xf2e9,
  "smiley-happy": 0xf3f1,
  "smiley-happy-square": 0xf47f,
  "smiley-neutral": 0xf3f2,
  "smiley-plus": 0xeb35,
  "smiley-sad": 0xf3f3,
  "snowflake": 0xf480,
  "soccer-ball": 0xf481,
  "sort-ascending": 0xf2ea,
  "sort-descending": 0xf2eb,
  "source-control": 0xf3b4,
  "sparkle": 0xf3f4,
  "sparkles": 0xf3f4,
  "speaker-hifi": 0xf482,
  "speaker-waves": 0xf3f5,
  "speaker-x": 0xf3f6,
  "spinner": 0xedca,
  "split": 0xf42f,
  "split-horizontal": 0xf3cd,
  "split-vertical": 0xf3ce,
  "sprint": 0xf426,
  "square": 0xf3f7,
  "square-dashed": 0xf58e,
  "square-dot": 0xf423,
  "squares": 0xf3fb,
  "squares-minus": 0xf3f8,
  "squares-plus": 0xf3f9,
  "squares-x": 0xf3fa,
  "stack": 0xf3fc,
  "star": 0xf3fd,
  "star-empty": 0xf3fd,
  "star-full": 0xeb59,
  "status-done": 0xf383,
  "status-draft": 0xedbb,
  "status-needs-attention": 0xf3aa,
  "stop": 0xed86,
  "stop-circle": 0xf3fe,
  "stopwatch": 0xf418,
  "storefront": 0xf483,
  "sun": 0xf3ff,
  "swatches": 0xf484,
  "symbol-folder": 0xf3b2,
  "sync": 0xea77,
  "t-shirt": 0xf485,
  "table": 0xf4bb,
  "tabs": 0xf2be,
  "tag": 0xf400,
  "tags-chevron-down": 0xf57f,
  "tags-chevron-left": 0xf581,
  "tags-chevron-right": 0xf583,
  "tags-chevron-up": 0xf585,
  "target": 0xebf8,
  "terminal": 0xf50e,
  "terminal-rectangle": 0xf401,
  "text-aa": 0xf55a,
  "text-ab": 0xeb2e,
  "text-b": 0xeaa3,
  "text-c": 0xf4cf,
  "text-d": 0xf4cd,
  "text-italic": 0xeb0d,
  "text-j": 0xf4f8,
  "text-r": 0xf4d2,
  "text-s": 0xf524,
  "text-strikethrough": 0xf525,
  "text-t": 0xf4d0,
  "text-t-square": 0xf402,
  "text-tt": 0xeb69,
  "text-y": 0xf4e0,
  "thinking-high": 0xf427,
  "thinking-low": 0xf428,
  "thinking-medium": 0xf429,
  "threads-parallel": 0xf40e,
  "threads-single": 0xf40f,
  "three-bars": 0xeb6a,
  "thumbs-down": 0xf560,
  "thumbs-up": 0xf561,
  "thumbsdown": 0xf560,
  "thumbsup": 0xf561,
  "traffic-cone": 0xf34d,
  "trafficCone": 0xf34d,
  "trash": 0xf403,
  "trashcan": 0xf403,
  "tray": 0xeb09,
  "treasure-chest": 0xf486,
  "trending-down": 0xf487,
  "trending-up": 0xf488,
  "triangle-small-down": 0xeb6e,
  "triangle-small-left": 0xeb6f,
  "triangle-small-right": 0xeb70,
  "triangle-small-up": 0xeb71,
  "twig": 0xf504,
  "unfold-dashed": 0xede8,
  "unlock": 0xf3d2,
  "unmute": 0xf3f5,
  "unverified": 0xeb76,
  "vault": 0xf489,
  "verified": 0xf3e9,
  "versions": 0xf404,
  "video-camera": 0xf405,
  "vm": 0xf3a8,
  "vr": 0xf48a,
  "vr-headset": 0xf562,
  "vr-headset-head": 0xf563,
  "wallet": 0xf48b,
  "wand": 0xf3f4,
  "warning": 0xea6c,
  "watch": 0xeb7c,
  "waveform": 0xf4c4,
  "whole-word": 0xeb7e,
  "window": 0xf406,
  "window-pointer-arrow": 0xebd1,
  "windows": 0xf407,
  "wrench": 0xeb6d,
  "x": 0xf409,
  "x-circle": 0xf408,
  "yarn": 0xf514,
  "zap": 0xf3f4,
  "zipper": 0xf552,
  "zoom-in": 0xf3d4,
  "zoom-out": 0xf3d3,
  "zzz": 0xf48e,
} as const;

// `computer` is the recovered product's semantic alias for the shipped
// `device-desktop` glyph. It is retained because ComputerHeaderControl
// already exposes that exact semantic name.
export const SAND_ICON_ALIASES = {
  computer: SAND_ICON_OUTLINE_CODE_POINTS["device-desktop"],
} as const;
export const SAND_ICON_ALIASES_WINDOWS = {
  computer: SAND_ICON_OUTLINE_CODE_POINTS_WINDOWS["device-desktop"],
} as const;

export type SandIconName = keyof typeof SAND_ICON_OUTLINE_CODE_POINTS | keyof typeof SAND_ICON_ALIASES;
export type SandIconPlatform = "mac" | "windows";
export type SandIconVariant = "outline" | "filled";
export type SandIconSize = "xs" | "sm" | "md" | "base" | "lg" | "xl" | "2xl" | number;
export type SandIconColor =
  | "primary" | "secondary" | "tertiary" | "quaternary"
  | "git-added" | "git-modified" | "git-removed" | "git-untracked"
  | "cyan" | "blue" | "red" | "green" | "success" | "danger"
  | "yellow" | "magenta" | "orange" | "purple" | "accent" | "brand";

export const SAND_ICON_FONT = {
  family: "cursor-icons",
  asset: "cursor-icons-16-f_W_ogc-.woff2",
  bytes: 124084,
  sha256: "2058c08b796a3f7ec9fdb219e16b21a350910a3e8cc231939600ee7efbf08bcb",
} as const;

export function sandIconPlatform(): SandIconPlatform {
  return typeof navigator !== "undefined" && /win/i.test(navigator.platform) ? "windows" : "mac";
}

export function sandIconCodePoint(name: SandIconName, variant: SandIconVariant = "outline", platform: SandIconPlatform = sandIconPlatform()): number {
  const aliases = platform === "windows" ? SAND_ICON_ALIASES_WINDOWS : SAND_ICON_ALIASES;
  if (name in aliases) return aliases[name as keyof typeof aliases];
  const table = variant === "filled"
    ? platform === "windows" ? SAND_ICON_FILLED_CODE_POINTS_WINDOWS : SAND_ICON_FILLED_CODE_POINTS
    : platform === "windows" ? SAND_ICON_OUTLINE_CODE_POINTS_WINDOWS : SAND_ICON_OUTLINE_CODE_POINTS;
  return table[name as keyof typeof SAND_ICON_OUTLINE_CODE_POINTS];
}

export function sandIconGlyph(name: SandIconName, variant: SandIconVariant = "outline", platform?: SandIconPlatform): string {
  return String.fromCodePoint(sandIconCodePoint(name, variant, platform));
}

export function sandIconStyle(size: SandIconSize = "sm", color?: SandIconColor): CSSProperties {
  // @evidence src/app/dist/renderer/assets/index-UbX-y3il.js#byteOffset=1222466
  // @evidence recovered/frontend/app/assets/index-UbX-y3il.js#byteOffset=1539571
  // Dr/TBt's shipped SandKit icon sizes are literal pixels. The unqualified
  // foreground colors are also standalone tokens; appending `-primary` makes
  // invalid variables such as --cursor-icon-secondary-primary and leaves the
  // glyph to inherit an unrelated ancestor color.
  const cssSize = typeof size === "number"
    ? `${size}px`
    : `${({ xs: 10, sm: 12, md: 14, base: 14, lg: 16, xl: 18, "2xl": 24 } as const)[size]}px`;
  const semanticColor = color === "primary" || color === "secondary" || color === "tertiary" || color === "quaternary"
    ? `var(--cursor-icon-${color})`
    : color === "brand"
      ? "var(--cursor-brand)"
      : color == null
        ? undefined
        : `var(--cursor-icon-${color === "success" ? "green" : color === "danger" ? "red" : color}-primary)`;
  return {
    color: semanticColor,
    fontFamily: SAND_ICON_FONT.family,
    fontSize: cssSize,
    lineHeight: 1,
  };
}
